import React, {useState, useEffect} from "react";

export default function UltimateFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M475.228,309.815l-0.876-49.583c-0.017-0.003-0.034-0.005-0.051-0.008v-0.617
	c0.013,0.002,0.027,0.004,0.04,0.006l-0.256-14.44c-0.001-0.357-0.071-21.245-0.871-50.432l0-0.001l-0.001-0.031
	c-0.046-1.678-0.094-3.379-0.145-5.11c-0.013-0.001-0.028-0.001-0.041-0.002l-1.32-36.233l0.013,0.001
	c-0.018-0.394-0.038-0.794-0.056-1.189l-0.006-0.176l-0.005-0.054c-0.42-9.071-0.909-18.338-1.486-27.584
	c-1.082-17.365-2.62-30.821-4.204-41.094l-0.002-0.027l-0.021-0.122c-0.272-1.756-0.544-3.429-0.816-5
	c-0.01-0.001-0.019-0.002-0.029-0.002l-0.105-0.62c0.008,0.001,0.017,0.001,0.025,0.002c-0.13-0.74-0.26-1.454-0.389-2.154
	l-0.006-0.033l-0.001-0.001c-0.796-4.305-1.574-7.849-2.281-10.712c-2.334-9.443-4.347-13.484-4.882-14.458l0-0.001l-0.233-0.936
	l-1.406-17.5c-0.07-0.011-0.156-0.025-0.256-0.04c-0.02-0.003-0.041-0.006-0.062-0.01c-0.059-0.01-0.123-0.019-0.192-0.03
	c-0.024-0.004-0.048-0.007-0.074-0.012c-0.05-0.007-0.102-0.016-0.157-0.023c-0.027-0.005-0.055-0.009-0.084-0.013
	c-0.067-0.011-0.137-0.022-0.21-0.034c-0.05-0.007-0.103-0.015-0.157-0.023c-0.013-0.002-0.027-0.004-0.04-0.007
	c-0.053-0.007-0.107-0.016-0.162-0.024c-0.016-0.003-0.031-0.005-0.047-0.008c-0.036-0.005-0.074-0.011-0.11-0.017
	c-0.038-0.006-0.075-0.012-0.114-0.017c-0.038-0.006-0.077-0.012-0.116-0.017c-0.057-0.009-0.115-0.019-0.174-0.028
	c-0.041-0.005-0.081-0.011-0.122-0.018c-0.151-0.022-0.308-0.046-0.471-0.071c-0.036-0.005-0.071-0.01-0.108-0.016
	c-0.036-0.005-0.073-0.01-0.109-0.016c-0.041-0.007-0.083-0.013-0.123-0.018c-0.041-0.007-0.083-0.013-0.125-0.02l0.001,0.025
	L437.134,29.1l0-0.019c-0.476-0.06-0.967-0.121-1.455-0.182l-0.039-0.005c0,0-0.008,0-0.008-0.001
	c-0.977-0.122-1.969-0.244-2.992-0.368c-0.221-0.027-0.442-0.054-0.665-0.081c-0.111-0.013-0.223-0.027-0.335-0.039
	c-0.111-0.014-0.223-0.027-0.336-0.04c-0.224-0.027-0.449-0.054-0.676-0.081c-0.226-0.027-0.454-0.054-0.682-0.08
	c-0.114-0.014-0.228-0.026-0.343-0.039c-0.229-0.028-0.458-0.054-0.69-0.081c-0.576-0.067-1.158-0.134-1.745-0.199
	c-6.934-0.782-15.223-1.608-23.764-2.211c-0.001,0-0.002,0-0.003-0.001c-5.853-1.563-52.897-0.259-52.897-0.259l-4.663,0.468
	c-7.544,0.578-14.798,1.307-20.972,2.003c-0.939,0.107-1.866,0.213-2.779,0.319c-0.341,0.04-0.681,0.08-1.02,0.121
	c-0.226,0.026-0.451,0.053-0.673,0.08c-0.149,0.018-0.297,0.036-0.445,0.053c-0.313,0.037-0.614,0.075-0.923,0.112l-0.044,0.004
	l-0.069,0.009c-0.494,0.06-0.994,0.121-1.478,0.18c-0.421,0.051-0.838,0.104-1.251,0.155c-0.287,0.036-0.572,0.073-0.855,0.108
	l-0.001,0.043l-15.701,2.129l0.001-0.017c-0.113,0.017-0.224,0.033-0.332,0.049c-0.05,0.008-0.098,0.015-0.147,0.023
	c-0.053,0.008-0.107,0.016-0.159,0.024c-0.048,0.008-0.095,0.014-0.143,0.021c-0.075,0.011-0.149,0.023-0.221,0.034
	c-0.045,0.006-0.09,0.014-0.133,0.02c-0.218,0.032-0.424,0.063-0.615,0.093c-0.074,0.011-0.145,0.022-0.215,0.033
	c-0.077,0.012-0.151,0.024-0.223,0.035c-0.1,0.014-0.196,0.029-0.286,0.043c-0.103,0.017-0.201,0.032-0.292,0.045
	c-0.056,0.009-0.11,0.018-0.161,0.025c-0.052,0.008-0.1,0.015-0.146,0.023c-0.023,0.004-0.045,0.008-0.067,0.011
	c-0.068,0.01-0.129,0.02-0.183,0.029c-0.033,0.004-0.063,0.01-0.091,0.013l-1.412,17.577l0,0l-0.244,0.89v0
	c-0.56,1.029-2.557,5.088-4.865,14.429c-0.757,3.063-1.595,6.911-2.449,11.631l-0.005,0.015l-0.062,0.354
	c-0.054,0.301-0.108,0.592-0.162,0.9c0.001,0,0.003,0,0.005,0l-0.109,0.622c-0.001,0-0.003,0-0.004,0
	c-0.036,0.205-0.071,0.423-0.107,0.631l-0.048,0.276l0.001,0.002c-1.816,10.713-3.651,25.468-4.889,45.332
	c-0.45,7.221-0.869,14.811-1.251,22.622l-0.003,0.018l-0.008,0.2c-0.099,2.038-0.198,4.082-0.292,6.148l0.057-0.006l-1.39,36.249
	c-0.006,0-0.012,0.001-0.018,0.001c-0.02,0.671-0.04,1.34-0.059,2.004c-0.883,30.782-0.953,53.345-0.954,53.57l-0.121,6.825
	l-0.134,0.492v7.725c-0.004,0.001-0.007,0.001-0.011,0.002l-0.877,49.603c0.08,0.995,3.437,43.036,3.918,48.967
	c0.485,5.982,0.975,44.857,0.98,45.248c-0.005,0.537-0.484,53.158,0,61.542c0.508,8.817,1.314,15.909,1.739,16.97
	c0.977,0.482,12.184,2.232,26.419,2.979c12.512,0.655,29.691,0.66,40.656-3.019c0.864-4.803,4.867-39.956,5.52-59.538
	c0.653-19.606-0.993-68.225-1.469-73.929c-0.463-5.565-1.013-37.61,0.659-45.803c1.283-6.287,4.196-27.729,5.761-39.249
	c0.423-3.105,0.756-5.559,0.93-6.777c0.274-1.921,0.385-5.835,0.512-10.367c0.249-8.881,0.591-21.044,2.434-27.875
	c1.378-5.104,2.429-10.835,3.202-15.55l0.001-0.001l0.055-0.341c0.074-0.456,0.149-0.916,0.218-1.35c-0.001,0-0.002,0-0.002,0
	l0.104-0.651c0,0,0,0,0.001,0c0.009-0.058,0.017-0.109,0.026-0.167l0.019-0.118l0.193-1.243c0.001-0.008,0.003-0.017,0.004-0.025
	l0,0l0.616-3.964c0.006-0.034,0.01-0.062,0.016-0.095l0.149-0.847c0.049-0.262,0.095-0.487,0.134-0.629
	c0.024-0.089,0.047-0.273,0.069-0.53l0-0.002l0-0.007c0.063-0.741,0.12-2.099,0.187-3.712c0.035-0.837,0.075-1.775,0.12-2.753
	l0.066-1.397c0.197-3.973,0.505-8.694,1.1-13.036c0.862-6.284,2.095-10.118,3.754-11.642l1.751-0.371
	c1.908,1.187,3.299,5.128,4.243,12.013c0.82,5.992,1.101,12.729,1.286,17.187c0.052,1.228,0.097,2.3,0.143,3.074v0.001l0,0.001
	c0.036,0.6,0.073,1.026,0.114,1.177c0.095,0.346,0.218,1.052,0.381,2.076c0.001-0.018,0.002-0.038,0.003-0.056l0.466,2.994
	c-0.001,0.021-0.003,0.05-0.003,0.07c0.1,0.648,0.206,1.341,0.321,2.072c0.005,0.001,0.011,0.002,0.016,0.003l0.1,0.643
	c-0.005-0.001-0.009-0.001-0.014-0.002c0.104,0.655,0.215,1.339,0.331,2.041l0.006,0.037l0.001,0.001
	c0.766,4.627,1.794,10.16,3.128,15.103c1.844,6.831,2.184,18.993,2.434,27.875c0.128,4.531,0.238,8.446,0.512,10.367
	c0.175,1.218,0.508,3.671,0.929,6.777c1.566,11.52,4.48,32.962,5.763,39.249c1.672,8.193,1.122,40.237,0.658,45.803
	c-0.475,5.704-2.122,54.323-1.469,73.929c0.653,19.582,4.656,54.735,5.52,59.537c10.965,3.679,28.144,3.675,40.656,3.02
	c14.234-0.747,25.442-2.498,26.419-2.98c0.426-1.06,1.231-8.153,1.74-16.969c0.483-8.384,0.004-61.005-0.001-61.535
	c0.005-0.399,0.496-39.273,0.981-45.255C471.792,352.852,475.149,310.81,475.228,309.815z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M193.63,338.13l-5.179-0.348c-0.156-1.494-0.323-2.884-0.503-4.153c-4-28.205-4.507-52.918-4.521-53.697
	c-0.073-0.565-1.908-14.66-4.918-31.315c-0.564-3.121-1.196-6.467-1.884-9.912h0.002l0.62-0.012
	c0.001,0.004,0.002,0.008,0.003,0.012c0.373-0.007,1.1-0.023,2.119-0.055l0.023,0v0c6.686-0.21,26.166-1.125,45.668-4.979
	c-1.105-3.416-2.304-6.913-3.63-10.591c-1.706-4.733-3.609-9.715-5.658-14.808c-1.915-4.766-4.005-9.746-6.212-14.802
	c-2.048-4.698-4.248-9.575-6.536-14.5c-2.105-4.53-4.336-9.208-6.629-13.899c-2.085-4.265-4.27-8.641-6.493-13.005
	c-1.988-3.904-4.05-7.878-6.126-11.815c-1.818-3.447-3.678-6.922-5.528-10.329c-1.566-2.884-3.147-5.759-4.701-8.549
	c-1.243-2.231-2.468-4.408-3.643-6.47c-0.232-0.408-0.457-0.801-0.677-1.186l0,0l-0.002-0.003c-0.591-1.034-1.144-1.995-1.675-2.91
	c-0.1-0.172-0.201-0.345-0.301-0.518c-0.001,0.04-0.003,0.078-0.004,0.118l-0.58-0.97c0.005-0.159,0.01-0.315,0.015-0.475
	l0.873-30.538l0.169-1.285v-5.021v-4.562V54.951c0-0.114-0.071-0.218-0.176-0.258c-1.687-0.642-3.52-1.287-5.418-1.929l-0.001-0.004
	l-0.138-0.044c-0.997-0.337-2.006-0.673-3.034-1.006l-0.001,0.044l-0.607-0.192l0.001-0.046c-3.017-0.974-6.108-1.925-9.049-2.824
	l-0.019-0.006l-14.677-4.494l0-0.016c-0.294-0.087-0.586-0.167-0.88-0.254l-0.466-0.143l-0.042-0.004
	c-1.362-0.398-2.725-0.796-4.08-1.176c-10.447-2.612-19.857-5.306-28.732-8.228l-0.001,0.01l-15.961-4.695l0.006-0.062
	c-0.356-0.088-0.72-0.167-1.078-0.253l-0.17-0.05l-0.005,0.009c-3.98-0.948-8.096-1.75-12.286-2.255
	c-0.005,0-0.012-0.001-0.017-0.001c-0.069-0.001-0.138-0.003-0.209-0.004c-0.122,0.032-0.22,0.134-0.244,0.265
	c-2.59,14.225-6.835,24.492-8.428,28.03l-1.141,2.298L60.859,57.7c-3.659,6.833-6.727,13.802-9.183,20.884
	c0,0-4.316,11.556-5.635,22.063c-0.007,0.054-0.013,0.102-0.02,0.155c-0.169,1.024-0.332,2.049-0.477,3.076l0.057-0.062
	c0.006,0.006,0.012,0.012,0.018,0.018c-0.036,0.257-0.071,0.505-0.106,0.74c-0.02-0.019-0.038-0.038-0.057-0.057
	c-0.102,0.745-0.188,1.492-0.277,2.238c-0.607,3.721-0.75,3.313-0.555,5.629l0.006,0.045c-0.128,1.703-0.233,3.409-0.295,5.12
	c-0.604,16.607,2.215,28.382,3.093,31.596c0.224,0.82,0.378,1.664,0.457,2.511c0.302,3.223,0.895,10.68,1.147,21.595l0.107,7.697
	c0.009,1.601,0.013,3.236,0.005,4.945c-0.074,15.323,1.964,32.251,3.453,44.612c0.677,5.614,1.26,10.463,1.495,13.883
	c0.539,7.854-0.732,17.125-1.66,23.896c-0.372,2.704-0.691,5.039-0.815,6.698c-0.283,3.833-0.138,17.902-0.026,25.946
	c0.077,5.526-0.601,11.032-2.016,16.367c-2.564,9.67-5.989,23.525-7.749,34.624c-2.763,17.432-7.054,58.625-7.097,59.039
	c-0.067,0.53-6.566,51.953-7.087,61.186c7.102,2.736,13.831,4.699,20.076,6.095l-0.001,0.006l0.221,0.044
	c0.325,0.072,0.655,0.15,0.978,0.219c0.001-0.007,0.002-0.018,0.003-0.025l0.601,0.119c-0.001,0.009-0.003,0.023-0.004,0.032
	c1.555,0.326,3.076,0.615,4.565,0.873l0.065,0.013l0.001-0.002c9.618,1.665,17.808,1.984,24.014,1.804
	c12.925-0.374,20.244-2.842,20.798-3.162c0.524-0.916,3.802-15.213,5.19-31.224c1.385-15.973,10.458-53.666,10.55-54.045
	l0.005-0.018c0.105-0.341,7.199-23.308,12.078-40.443c-26.211,0.169-53.769-4.386-58.261-5.16l-0.927-0.22
	c2.909-17.405,5.896-33.439,8.631-44.761c2.665-11.038,5.787-31.22,9.29-60.033l1.411,0.308h0
	c5.183,1.153,29.164,6.243,52.274,7.144l0.002,0.003l0.082,0.001c0.171,0.007,0.343,0.015,0.514,0.022l0.004-0.016l0.627,0.006
	l-2.597,10.177c3.54,1.631,5.634,4.227,6.774,6.14c1.263,2.118,1.651,3.834,1.667,3.906l0.002,0.012
	c0.021,0.12,2.17,12.237,3.553,27.456c1.329,14.627,2.875,17.459,2.959,17.603c0.226,0.295,3.066,4.123,3.066,9.962l-0.004,0.044
	c-1.675,11.736,0.148,55.414,1.295,71.469c1.045,14.639,1.178,48.387,1.183,49.884c0.098,0.222,1.184,2.142,9.739,3.286
	c6.522,0.87,13.075,1.349,21.011,1.662l0,0.002l0.316,0.011c0.139,0.005,0.27,0.012,0.409,0.017c0-0.001,0-0.002,0-0.003
	l0.609,0.021c0,0.001,0,0.003,0,0.004c0.82,0.03,1.664,0.057,2.516,0.084l0.257,0.009v0c3.07,0.095,6.351,0.173,9.917,0.245
	c14.701,0.295,24.419-4.008,25.736-4.627c0.179-2.221,1.979-24.866,1.169-32.253c-0.81-7.39-1.056-27.373,0.971-37.849
	c0.065-0.333,0.112-0.672,0.15-0.96c0.258-1.985,0.368-4.028,0.474-6.003l0.013-0.223c0.187-3.462,0.306-6.874,0.396-9.756
	c0.116-3.675,0.216-7.599,0.314-12.352c0.067-3.181,0.127-6.527,0.183-10.141C215.94,338.704,201.083,338.411,193.63,338.13z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M314.717,29.103l-0.479,19.78l-0.016,0.611l-0.227,9.371c-0.007,0.31-0.256,0.562-0.566,0.571l-13.254,0.428
	c-0.27,0.008-0.522-0.092-0.711-0.282c-0.191-0.191-0.289-0.444-0.279-0.713l0.341-8.976l0.023-0.611l0.691-18.193
	c0.016-0.003,0.031-0.005,0.047-0.007c0.085-0.013,0.17-0.024,0.257-0.038c0.027-0.004,0.055-0.008,0.084-0.012
	c0.058-0.009,0.116-0.017,0.175-0.026c0.136-0.021,0.274-0.041,0.415-0.061c0.057-0.008,0.114-0.016,0.172-0.025
	c0.047-0.006,0.093-0.014,0.14-0.021c0.304-0.044,0.617-0.089,0.94-0.136c0.414-0.059,0.843-0.12,1.289-0.184
	c0.072-0.011,0.145-0.022,0.218-0.031c0.105-0.015,0.211-0.03,0.319-0.046c0.19-0.026,0.385-0.054,0.581-0.083
	c0.536-0.075,1.092-0.152,1.668-0.232c0.411-0.056,0.833-0.114,1.263-0.173c0.185-0.026,0.372-0.051,0.56-0.076
	c0.15-0.021,0.301-0.041,0.453-0.062c0.012-0.001,0.025-0.003,0.037-0.005c0.178-0.023,0.357-0.047,0.539-0.072
	c0.09-0.012,0.18-0.024,0.272-0.037c0.224-0.03,0.448-0.06,0.676-0.09c0.051-0.007,0.103-0.013,0.153-0.02
	c0.234-0.031,0.469-0.062,0.706-0.094c0.238-0.031,0.476-0.062,0.719-0.095c0.096-0.011,0.193-0.025,0.29-0.037
	c0.194-0.025,0.39-0.051,0.587-0.077c0.591-0.076,1.193-0.154,1.806-0.232C314.643,29.113,314.679,29.108,314.717,29.103"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M233.017,272.446c-0.01,0.74-0.021,1.507-0.022,2.262c-0.004,1.561-0.008,3.123-0.012,4.685
	c-0.012,3.795-0.028,7.653-0.046,11.466c-0.022,4.583-0.049,9.122-0.079,13.49c-0.037,5.126-0.076,9.899-0.124,14.591
	c-0.054,5.298-0.112,10.129-0.178,14.767c-0.02,1.329-0.038,2.621-0.059,3.881c-21.52,1.497-40.17,0.555-43.43,0.368
	c-0.161-1.578-0.337-3.043-0.526-4.376c-4.037-28.479-4.51-53.391-4.515-53.639l-0.002-0.034c-0.018-0.143-1.865-14.43-4.923-31.358
	c-0.559-3.091-1.181-6.398-1.861-9.807c2.81-0.051,25.302-0.587,47.81-5.034c0.427,1.319,0.841,2.627,1.242,3.927
	c1.523,4.936,2.784,9.495,3.857,13.933l0.143,0.593c1.063,4.392,2.163,8.934,2.577,13.415
	C233.079,267.863,233.048,270.194,233.017,272.446"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M69.872,27.106c-0.02,0.049-0.034,0.102-0.043,0.156c-0.038,0.209-0.077,0.417-0.115,0.624l-1.341,0.003
	c-0.485-0.048-0.93,0.287-1.018,0.771c-3.203,17.586-8.312,27.731-8.364,27.832l-0.005,0.01c-0.041,0.09-0.369,0.905,0.65,2.21
	c-0.143,0.273-0.285,0.546-0.427,0.82c-0.843-0.604-1.183-1.093-1.187-1.097l-0.014-0.02c-0.802-1.006-0.616-1.591-0.607-1.618
	c0.19-0.381,5.879-11.916,9.061-29.388c0.013-0.074,0.048-0.271,0.402-0.271l1.759-0.004h0.011
	C68.643,27.134,69.201,27.112,69.872,27.106"
      />
      <path
        fill="#C6C6C6"
        d="M79.615,85.652l-0.298,1.203c-0.021,0.082-0.071,0.151-0.143,0.193c-0.072,0.043-0.157,0.055-0.238,0.035
	c-3.606-0.919-21.619-5.47-27.989-6.336c0.169-0.515,0.341-1.031,0.518-1.545C53.406,79.585,66.383,82.177,79.615,85.652"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M142.775,142.897c-2.066,9.517-4.648,20.508-5.5,22.881c-1.558,3.344-2.317,4.263-3.432,5.059
	c-1.086,0.775-14.224,3.367-16.888,3.139c-0.876-0.076-1.763-0.265-2.621-0.446l-0.369-0.077c-1.556-0.325-3.071-0.678-4.346-0.98
	c-1.3-0.307-2.66-0.639-4.16-1.01c-1.356-0.337-2.755-0.656-4.161-0.949c-1.031-0.214-2.063-0.425-3.094-0.635
	c-1.811-0.368-3.68-0.748-5.512-1.149c-0.584-0.127-1.189-0.252-1.772-0.372c-2.304-0.477-4.684-0.97-6.842-1.818
	c-2.272-0.893-4.415-2.562-6.486-4.174c-0.509-0.395-0.989-0.768-1.474-1.133c-1.027-0.774-2.377-1.804-3.69-2.905
	c-0.14-0.121-0.292-0.239-0.451-0.364c-0.511-0.399-1.092-0.853-1.38-1.379c-0.648-1.18-0.935-2.319-0.925-5.947
	c0.228-2.439,2.374-13.383,4.29-22.406l18.749,3.977L142.775,142.897z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M148.352,48.575c-0.039,1.556-0.263,10.489-0.458,18.245c-0.005,0.21-0.011,0.419-0.015,0.626
	c-0.133,5.29-0.251,9.913-0.28,11.078c-4.141,0.144-11.893-1.745-13.341-2.109l0.364-12.428l0.018-0.623l0.545-18.619
	L148.352,48.575z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M99.789,34.318c-0.203,1.784-1.429,12.576-2.382,20.957c-0.024,0.203-0.047,0.405-0.069,0.605
	c-0.518,4.551-0.943,8.283-1.057,9.289c-4.601-0.003-13.092-2.212-14.654-2.63l0.735-7.053l0.063-0.61l2.61-25.056L99.789,34.318z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M146.977,82.811l-0.675,19.873c-5.325,0.998-25.244,5.654-33.335,8.654l-13.928,4.848
	c0.393-4.383,0.768-8.616,1.121-12.666l12.146-5.023c1.366-0.566,2.749-1.191,4.108-1.858
	C125.585,92.136,143.898,84.15,146.977,82.811"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M88.623,88.166l-2.209,12.747c-0.171,0.547-0.757,0.892-1.368,0.802L46.87,96.124
	c1.008-4.975,2.303-9.907,3.884-14.788c6.229,0.821,24.409,5.415,28.031,6.338c0.076,0.019,0.152,0.028,0.229,0.028
	c0.164,0,0.327-0.044,0.472-0.13c0.212-0.128,0.363-0.33,0.422-0.571l0.296-1.194C83.041,86.559,85.883,87.348,88.623,88.166"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M139.787,249.771l-2.385,9.346l-0.017-0.005c-0.023,0.092-0.103,0.431-0.229,0.969
	c-0.001,0.004-0.002,0.008-0.004,0.014l-0.049,0.19l0.004,0.002c-0.988,4.239-4.204,18.583-3.925,24.513
	c0.317,6.784-0.945,42.49-1.934,50.182c-0.309,2.404-2.139,9.275-4.477,17.486c-26.964,0.175-55.36-4.653-58.597-5.218
	c2.91-17.417,5.899-33.457,8.633-44.78c2.668-11.054,5.793-31.238,9.297-60.051C88.736,243.021,114.87,248.877,139.787,249.771"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M473.047,188.987c-5.036-0.199-11.63-0.834-15.024-2.71c-5.675-3.137-12.283-9.603-12.871-11.206
	c-0.42-1.147,2.055-14.643,3.855-23.613l22.738,2.522C472.3,166.243,472.724,178.103,473.047,188.987"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M306.75,175.072c-0.588,1.603-7.197,8.069-12.871,11.206c-3.367,1.86-9.881,2.5-14.902,2.705
	c0.033-1.092,0.066-2.191,0.101-3.301c0.297-9.584,0.648-19.031,1.043-28.08c0.025-0.579,0.05-1.159,0.076-1.739
	c0.028-0.631,0.056-1.264,0.085-1.896l22.613-2.509C304.694,160.429,307.169,173.925,306.75,175.072"
      />
      <path
        fill="#C6C6C6"
        d="M349.03,75.019v1.535c0,0.424-0.297,0.779-0.662,0.792l-45.623,1.655c-0.231,0.009-0.435-0.199-0.463-0.472
	l-0.152-1.497c9.806-0.616,23.77-1.351,40.414-1.84C344.634,75.131,346.799,75.073,349.03,75.019"
      />
      <path
        fill="#C6C6C6"
        d="M449.65,76.915l-0.162,1.585c-0.028,0.274-0.233,0.482-0.463,0.473l-45.623-1.656
	c-0.364-0.012-0.661-0.367-0.661-0.79v-1.636C417.718,75.196,433.576,75.819,449.65,76.915"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M458.329,77.555l-1.208,14.688c-0.061,0.741-0.73,1.336-1.556,1.387l-57.829,3.503
	c-0.932,0.057-1.733-0.578-1.784-1.415l-1.301-20.961c2.456,0.032,4.939,0.072,7.448,0.121v1.65c0,0.776,0.563,1.406,1.28,1.432
	l45.624,1.656h0.036c0.553,0,1.027-0.453,1.088-1.049l0.163-1.595l-0.336-0.035C452.74,77.128,455.534,77.334,458.329,77.555"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M357.716,74.839l-1.295,20.878c-0.052,0.837-0.853,1.471-1.785,1.415l-57.827-3.502
	c-0.827-0.051-1.496-0.647-1.557-1.388l-1.206-14.671c2.082-0.148,4.577-0.318,7.442-0.499l0.156,1.522
	c0.061,0.595,0.535,1.049,1.088,1.049h0.036l45.624-1.657c0.718-0.025,1.28-0.654,1.28-1.432v-1.55
	C352.267,74.943,354.95,74.886,357.716,74.839"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M437.742,29.158l0.479,19.744l-0.61-0.016L437.13,29.08C437.336,29.105,437.539,29.132,437.742,29.158"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M443.962,29.979c0.07,0.01,0.14,0.02,0.21,0.029c-0.082-0.011-0.165-0.023-0.247-0.033
	c-0.074-0.011-0.149-0.02-0.224-0.031C443.788,29.956,443.875,29.967,443.962,29.979"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M445.236,30.153c0.045,0.006,0.091,0.013,0.137,0.02c-0.079-0.011-0.158-0.022-0.237-0.033
	c-0.051-0.008-0.1-0.014-0.151-0.021C445.069,30.131,445.153,30.141,445.236,30.153"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M446.451,30.322c0.061,0.009,0.121,0.017,0.18,0.026c-0.037-0.005-0.075-0.01-0.111-0.015
	c-0.074-0.011-0.15-0.022-0.225-0.032C446.348,30.308,446.399,30.316,446.451,30.322"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M446.687,30.355c0.078,0.011,0.156,0.021,0.233,0.032c-0.058-0.007-0.117-0.016-0.176-0.023l-0.113-0.016
	C446.649,30.351,446.668,30.354,446.687,30.355"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M453.51,49.311l-0.611-0.016L452.19,31.15c0.214,0.031,0.418,0.062,0.613,0.091L453.51,49.311z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M398.872,25.375l-6.807,27.35c-0.089,0.361-0.413,0.614-0.785,0.614h-31.619
	c-0.374,0-0.698-0.254-0.787-0.617L352.2,25.435c7.543-0.471,15.161-0.743,22.108-0.634l0.002,0.086
	c0.563-0.021,1.131-0.038,1.705-0.052c0.572,0.014,1.141,0.031,1.702,0.052l0.004-0.086
	C384.375,24.697,391.643,24.94,398.872,25.375"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M307.808,30.015c-0.43,0.059-0.852,0.117-1.263,0.173C306.956,30.131,307.377,30.073,307.808,30.015"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M314.606,29.118c-0.613,0.078-1.215,0.156-1.806,0.232C313.391,29.273,313.993,29.195,314.606,29.118"
      />
      <path
        fill={azomo}
        d="M390.035,33.727c0,0.564-0.419,1.007-0.964,1.007c-0.54,0-0.97-0.443-0.97-1.007c0-0.551,0.43-0.994,0.97-0.994
	C389.616,32.733,390.035,33.176,390.035,33.727 M388.342,33.727c0,0.443,0.31,0.794,0.734,0.794c0.413,0,0.718-0.351,0.718-0.788
	c0-0.442-0.305-0.8-0.723-0.8C388.652,32.933,388.342,33.291,388.342,33.727 M388.921,34.249h-0.218v-0.995
	c0.086-0.018,0.207-0.03,0.362-0.03c0.178,0,0.258,0.03,0.327,0.073c0.052,0.042,0.092,0.121,0.092,0.218
	c0,0.109-0.08,0.194-0.195,0.231v0.012c0.092,0.036,0.143,0.109,0.172,0.242c0.028,0.152,0.046,0.212,0.069,0.249h-0.236
	c-0.028-0.037-0.046-0.127-0.075-0.243c-0.017-0.109-0.074-0.157-0.194-0.157h-0.104V34.249z M388.927,33.685h0.104
	c0.12,0,0.217-0.042,0.217-0.146c0-0.09-0.063-0.151-0.2-0.151c-0.058,0-0.098,0.006-0.121,0.012V33.685z"
      />
      <path
        fill={azomo}
        d="M379.592,36.16l-1.583-3.099l-1.597,4.942l0.849,0.281l0.896-3.031l1.339,2.605l0.383-0.639
	c0.181-0.304,0.353-0.591,0.524-0.879c0.178-0.302,0.355-0.604,0.549-0.937l0.109-0.187l1.065,3.087l0.84-0.367l-1.712-4.653
	L379.592,36.16z"
      />
      <path
        fill={azomo}
        d="M373.903,33.325h-0.009c-0.655,0.002-1.257,0.259-1.694,0.726c-0.431,0.46-0.665,1.086-0.66,1.763
	c0.011,1.343,0.996,2.36,2.292,2.366h0.011c0.659,0,1.259-0.251,1.691-0.706c0.429-0.451,0.665-1.076,0.665-1.76
	c-0.001-0.671-0.227-1.279-0.637-1.71C375.145,33.565,374.556,33.325,373.903,33.325 M375.283,35.726
	c0.022,0.886-0.615,1.656-1.391,1.681c-0.329,0.01-0.653-0.129-0.913-0.394c-0.314-0.319-0.495-0.776-0.498-1.255
	c-0.005-0.927,0.597-1.633,1.4-1.641h0.012C374.637,34.117,375.26,34.836,375.283,35.726"
      />
      <path
        fill={azomo}
        d="M387.208,34.027c-0.414-0.448-0.996-0.697-1.639-0.702h-0.021c-1.354,0-2.347,1.001-2.363,2.387
	c-0.008,0.701,0.217,1.333,0.632,1.78c0.411,0.441,0.996,0.685,1.648,0.688h0.01c1.324,0,2.337-1.036,2.357-2.415
	C387.842,35.09,387.62,34.472,387.208,34.027 M385.487,37.41h-0.002c-0.323,0-0.648-0.159-0.916-0.445
	c-0.31-0.333-0.492-0.797-0.486-1.241c0.007-0.452,0.179-0.885,0.474-1.188c0.264-0.271,0.605-0.418,0.961-0.418h0.021
	c0.76,0.012,1.356,0.734,1.355,1.643c-0.001,0.448-0.148,0.866-0.416,1.176C386.215,37.242,385.863,37.41,385.487,37.41"
      />
      <polygon
        fill={azomo}
        points="363.75,32.173 360.982,37.749 361.801,38.289 363.738,34.04 365.874,38.283 366.699,37.704 "
      />
      <polygon
        fill={azomo}
        points="367.481,33.402 367.481,34.178 369.754,34.178 366.965,38.092 370.954,38.092 371.023,37.302 368.599,37.302 
	371.363,33.402 "
      />
      <polygon
        fill={azomo}
        points="365.499,40.741 365.87,40.741 366.609,42.39 367.344,40.741 367.714,40.741 367.714,42.844 367.368,42.844 
	367.368,41.404 366.727,42.844 366.488,42.844 365.843,41.404 365.843,42.844 365.499,42.844 "
      />
      <path
        fill={azomo}
        d="M368.839,41.149c0.282,0,0.476,0.133,0.578,0.27v-0.242h0.349v1.667h-0.349v-0.248c-0.106,0.142-0.305,0.275-0.584,0.275
	c-0.432,0-0.78-0.354-0.78-0.868S368.401,41.149,368.839,41.149 M368.912,41.449c-0.257,0-0.505,0.194-0.505,0.554
	c0,0.36,0.248,0.569,0.505,0.569c0.26,0,0.505-0.203,0.505-0.563C369.417,41.652,369.172,41.449,368.912,41.449"
      />
      <path
        fill={azomo}
        d="M370.893,41.149c0.218,0,0.448,0.103,0.575,0.26v-0.804h0.349v2.239h-0.349v-0.251c-0.106,0.151-0.305,0.278-0.578,0.278
	c-0.439,0-0.787-0.354-0.787-0.868S370.451,41.149,370.893,41.149 M370.963,41.449c-0.257,0-0.505,0.194-0.505,0.554
	c0,0.36,0.248,0.569,0.505,0.569c0.26,0,0.505-0.203,0.505-0.563C371.468,41.652,371.223,41.449,370.963,41.449"
      />
      <path
        fill={azomo}
        d="M372.987,42.871c-0.478,0-0.832-0.339-0.832-0.863c0-0.523,0.339-0.859,0.832-0.859c0.475,0,0.811,0.33,0.811,0.82
	c0,0.058-0.003,0.112-0.012,0.169h-1.274c0.024,0.276,0.221,0.442,0.475,0.442c0.212,0,0.33-0.103,0.394-0.233h0.372
	C373.659,42.638,373.396,42.871,372.987,42.871 M372.515,41.86h0.923c-0.006-0.257-0.209-0.421-0.466-0.421
	C372.739,41.439,372.552,41.597,372.515,41.86"
      />
      <path
        fill={azomo}
        d="M375.85,41.149c0.442,0,0.783,0.34,0.783,0.854s-0.345,0.868-0.783,0.868c-0.276,0-0.472-0.124-0.581-0.269v0.242h-0.346
	v-2.239h0.346v0.82C375.378,41.274,375.586,41.149,375.85,41.149 M375.774,41.449c-0.257,0-0.505,0.203-0.505,0.56
	c0,0.36,0.248,0.563,0.505,0.563c0.26,0,0.508-0.209,0.508-0.569C376.282,41.643,376.034,41.449,375.774,41.449"
      />
      <polygon
        fill={azomo}
        points="378.119,41.176 378.476,41.176 377.453,43.628 377.096,43.628 377.435,42.817 376.779,41.176 377.163,41.176 
	377.632,42.447 "
      />
      <path
        fill={azomo}
        d="M380.216,42.865c-0.421,0-0.745-0.23-0.745-0.603h0.37c0.015,0.173,0.136,0.312,0.375,0.312c0.242,0,0.378-0.13,0.378-0.308
	c0-0.509-1.117-0.179-1.117-0.954c0-0.369,0.294-0.599,0.724-0.599c0.402,0,0.687,0.212,0.717,0.572h-0.381
	c-0.012-0.142-0.136-0.273-0.355-0.278c-0.199-0.006-0.354,0.09-0.354,0.293c0,0.476,1.114,0.179,1.114,0.947
	C380.942,42.562,380.685,42.865,380.216,42.865"
      />
      <polygon
        fill={azomo}
        points="381.242,40.741 382.71,40.741 382.71,41.022 382.15,41.022 382.15,42.844 381.805,42.844 381.805,41.022 
	381.242,41.022 "
      />
      <rect fill={azomo} x="383.057" y="40.741" width="0.345" height="2.103" />
      <polygon
        fill={azomo}
        points="383.856,40.741 384.228,40.741 384.967,42.39 385.702,40.741 386.071,40.741 386.071,42.844 385.726,42.844 
	385.726,41.404 385.085,42.844 384.846,42.844 384.201,41.404 384.201,42.844 383.856,42.844 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.61"
        strokeMiterlimit="10"
        d="M49.195,478.979
	c0,0,15.87-129.012,27.344-176.529c3.188-13.202,6.711-38.059,10.137-67.074"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="146.982"
        y1="85.341"
        x2="147.398"
        y2="85.15"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="148.23"
        y1="84.766"
        x2="148.231"
        y2="84.766"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.918,0.917"
        d="M148.231,84.766
	l1.448-0.667c0.928-0.363,3.449-1.918,4.142-2.688c0.311-0.345,0.713-0.741,0.928-1.171c0.651-1.303,1.303-8.328,1.466-10.194"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M156.216,70.045
	c0.025-0.29,0.039-0.455,0.039-0.455"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M154.803,69.429
	c-0.012,0.151-0.025,0.303-0.039,0.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.877,0.876"
        d="M154.683,70.757
	c-0.379,3.856-1.032,8-1.38,8.768c-0.073,0.146-0.321,0.414-0.502,0.61c-0.061,0.067-0.121,0.132-0.178,0.196
	c-0.483,0.536-2.758,1.962-3.529,2.263l-0.038,0.015l-0.037,0.016l-1.432,0.609"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="147.586"
        y1="83.234"
        x2="147.165"
        y2="83.413"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="99.741"
        y1="105.925"
        x2="100.166"
        y2="105.757"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="101.004"
        y1="105.424"
        x2="101.005"
        y2="105.424"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.903,0.902"
        d="
	M101.005,105.424l13.065-5.18c2.67-1.393,5.933-3.019,9.817-4.84c4.597-2.154,16.252-7.308,20.015-8.979"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M143.902,86.425
	c0.153-0.067,0.292-0.13,0.418-0.186l0.003,0.458"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="144.331"
        y1="87.637"
        x2="144.331"
        y2="87.638"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.941,0.94"
        x1="144.331"
        y1="87.638"
        x2="144.43"
        y2="100.813"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M144.43,100.813l0.003,0.458
	c-0.139,0.025-0.289,0.053-0.449,0.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="143.089"
        y1="101.526"
        x2="143.089"
        y2="101.526"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.913,0.912"
        d="
	M143.088,101.526c-6.395,1.261-22.733,4.935-29.815,7.591l-13.956,5.062"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="99.316"
        y1="114.179"
        x2="98.886"
        y2="114.335"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="99.741"
        y1="104.707"
        x2="100.16"
        y2="104.525"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="100.995"
        y1="104.163"
        x2="100.996"
        y2="104.163"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.911,0.91"
        d="M100.996,104.163
	l13.275-5.751c2.362-1.214,5.297-2.657,8.934-4.36c6.045-2.831,19.085-8.573,22.603-10.121"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M145.808,83.931
	c0.16-0.07,0.3-0.132,0.418-0.184l-0.012,0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="146.189"
        y1="85.133"
        x2="146.189"
        y2="85.134"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        x1="146.189"
        y1="85.134"
        x2="145.736"
        y2="101.888"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M145.736,101.888l-0.012,0.458
	c-0.141,0.017-0.292,0.038-0.453,0.063"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="144.378"
        y1="102.554"
        x2="144.377"
        y2="102.554"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.906,0.905"
        d="
	M144.377,102.555c-6.552,1.144-23.792,5.505-31.225,8.274c0,0-9.951,3.347-13.976,4.872"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M99.176,115.701
	c-0.151,0.057-0.293,0.112-0.427,0.164"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M96.869,89.409
	c-0.188-0.067-0.377-0.133-0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.235,1.233"
        d="M95.134,88.809
	c-15.92-5.391-39.092-10.083-43.068-10.872"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M52.064,77.937
	c-0.385-0.076-0.59-0.116-0.59-0.116"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M97.154,87.119
	c-0.188-0.067-0.377-0.134-0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.218,1.217"
        d="M95.436,86.522
	c-15.793-5.36-38.569-9.87-42.509-10.632"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M52.926,75.891
	c-0.386-0.075-0.591-0.113-0.591-0.113"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M96.227,132.479c0.018-0.2,0.036-0.4,0.054-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="96.389"
        y1="130.693"
        x2="96.389"
        y2="130.692"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.192,1.191"
        d="M96.389,130.692
	c3.253-35.823,5.925-68.82,6.312-73.626"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M102.702,57.066
	c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="102.6"
        y1="58.252"
        x2="102.6"
        y2="58.253"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="102.6"
        y1="58.253"
        x2="99.819"
        y2="91.463"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="99.819"
        y1="91.463"
        x2="99.769"
        y2="92.063"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M48.119,478.979c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="48.342"
        y1="477.183"
        x2="48.342"
        y2="477.183"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M48.342,477.182
	c1.96-15.731,16.444-130.516,27.121-174.732c3.703-15.335,6.156-31.713,10.066-66.579"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M85.529,235.87
	c0.022-0.199,0.044-0.398,0.067-0.599"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M94.958,132.235c0.019-0.2,0.037-0.4,0.055-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="95.12"
        y1="130.454"
        x2="95.12"
        y2="130.453"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.188,1.187"
        d="M95.12,130.453
	c3.242-35.708,5.904-68.59,6.291-73.386"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M101.411,57.066
	c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="101.31"
        y1="58.252"
        x2="101.31"
        y2="58.253"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="101.31"
        y1="58.253"
        x2="98.529"
        y2="91.463"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="98.528"
        y1="91.463"
        x2="98.478"
        y2="92.063"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M46.828,478.979c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="47.051"
        y1="477.182"
        x2="47.051"
        y2="477.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.21,1.209"
        d="M47.051,477.181
	c1.96-15.734,16.444-130.516,27.121-174.731c3.708-15.357,6.168-31.805,10.083-66.734"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M84.255,235.715
	c0.022-0.199,0.045-0.398,0.067-0.599"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M93.781,132.168c0.018-0.2,0.036-0.4,0.054-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="93.943"
        y1="130.388"
        x2="93.943"
        y2="130.387"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.187,1.186"
        d="M93.943,130.386
	c3.239-35.676,5.898-68.526,6.285-73.32"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M100.228,57.066
	c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="100.126"
        y1="58.252"
        x2="100.126"
        y2="58.253"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="100.126"
        y1="58.253"
        x2="97.345"
        y2="91.463"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="97.345"
        y1="91.463"
        x2="97.295"
        y2="92.063"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M45.645,478.979c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="45.866"
        y1="477.193"
        x2="45.866"
        y2="477.193"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.199,1.198"
        d="M45.867,477.192
	C47.822,461.5,62.31,346.675,72.989,302.449c3.713-15.378,6.18-31.889,10.1-66.878"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M83.088,235.571
	c0.022-0.199,0.045-0.398,0.067-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M159.745,172.757
	c0.007,0.171,0.018,0.37,0.034,0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="159.888"
        y1="174.556"
        x2="159.888"
        y2="174.557"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.205,1.204"
        d="
	M159.888,174.557c0.378,3.517,1.631,11.233,5.575,27.667c10.112,23.127,17.426,80.032,17.426,80.032s0.431,24.848,4.518,53.677
	c3.654,25.771,2.253,99.832,1.915,115.25"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M189.322,451.185
	c-0.005,0.211-0.009,0.412-0.013,0.601"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M158.669,176.907
	c0.027,0.191,0.057,0.39,0.088,0.595"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="158.943"
        y1="178.694"
        x2="158.943"
        y2="178.695"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.208,1.207"
        d="
	M158.944,178.695c0.727,4.479,2.171,11.795,5.013,23.637c10.112,23.127,17.426,80.032,17.426,80.032s0.431,24.849,4.519,53.677
	c3.643,25.693,2.261,99.378,1.917,115.107"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M187.819,451.149
	c-0.004,0.211-0.009,0.412-0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M157.939,179.661
	c0.033,0.193,0.067,0.391,0.102,0.593"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="158.253"
        y1="181.44"
        x2="158.253"
        y2="181.441"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.206,1.205"
        d="M158.253,181.44
	c0.829,4.551,2.215,11.178,4.521,20.784c10.111,23.127,17.426,80.031,17.426,80.031s0.43,24.849,4.518,53.678
	c3.645,25.712,2.259,99.491,1.917,115.143"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M186.635,451.077
	c-0.004,0.211-0.009,0.412-0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M88.218,87.823
	l-2.238,12.909c-0.109,0.368-0.518,0.597-0.951,0.533L46.72,95.654"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M86.371,87.341
	L84.79,98.027c-0.189,0.639-0.802,1.043-1.439,0.95l-36.214-5.304"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M101.665,467.741c0,0-0.204,0.041-0.591,0.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="99.87"
        y1="468.061"
        x2="99.87"
        y2="468.061"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        d="M99.87,468.061
	c-6.555,1.096-29.785,4.315-48.526-1.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M51.342,466.685
	c-0.192-0.059-0.384-0.118-0.575-0.178"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M46.168,465.232c0,0-0.207-0.062-0.576-0.173"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="44.485"
        y1="464.724"
        x2="44.484"
        y2="464.724"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.158,1.157"
        d="M44.484,464.724
	c-3.632-1.107-12.13-3.763-15.312-5.302"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M29.171,459.422
	c-0.2-0.097-0.379-0.189-0.535-0.276"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
	M229.857,437.435c0,0-18.747,6.871-39.527,4.103"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
	M185.901,441.029c0,0-19.714-1.243-27.929-4.171"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="M115.328,170.91
	c0.66,0.137,1.359,0.276,2.009,0.331c2.014,0.17,13.392-2.003,15.437-2.805c0.447-0.34,0.955-0.896,2.221-3.605
	c0.685-2.035,2.684-10.36,4.705-19.564l-47.574-10.194l-16.334-3.478c-1.841,8.778-3.423,17.035-3.655,19.116
	c-0.004,3.245,0.261,3.8,0.547,4.323c0.127,0.16,0.522,0.469,0.762,0.655c0.148,0.116,0.337,0.263,0.522,0.42
	c1.244,1.044,2.515,2.016,3.594,2.829c0.472,0.354,0.933,0.712,1.42,1.091l0.081,0.063c1.952,1.519,3.969,3.088,5.954,3.868
	c1.807,0.709,3.818,1.155,5.894,1.586c0,0,1.132,0.234,1.397,0.289c0.338,0.07,0.677,0.141,1.009,0.214
	c0.691,0.15,1.436,0.308,2.278,0.484c1.002,0.208,2.003,0.411,2.987,0.611l0.226,0.045c1.034,0.21,2.07,0.42,3.105,0.634
	c1.446,0.3,2.875,0.625,4.251,0.967c1.593,0.393,2.909,0.711,4.141,1.001c1.342,0.317,2.792,0.653,4.298,0.966L115.328,170.91z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
	M115.022,172.284c0.692,0.144,1.428,0.29,2.138,0.351c2.513,0.213,14.707-2.244,16.124-2.944c0.758-0.549,1.386-1.19,2.866-4.364
	c0.803-2.31,3.143-12.253,5.101-21.218l-48.819-10.442l-17.542-3.728c-1.797,8.518-3.729,18.385-3.972,20.758
	c-0.007,3.519,0.291,4.328,0.745,5.156c0.164,0.299,0.683,0.704,1.061,1c0.183,0.142,0.337,0.263,0.492,0.395
	c1.259,1.057,2.546,2.041,3.638,2.864c0.465,0.349,0.922,0.704,1.406,1.08l0.081,0.063c2.011,1.566,4.09,3.184,6.221,4.021
	c1.882,0.74,3.94,1.197,6.062,1.639c0,0,1.131,0.234,1.395,0.288c0.335,0.07,0.67,0.141,0.999,0.213
	c0.693,0.151,1.441,0.31,2.286,0.486c1.002,0.209,2.002,0.412,2.987,0.612l0.229,0.047c1.032,0.209,2.066,0.42,3.1,0.634
	c1.428,0.297,2.843,0.619,4.206,0.958c1.595,0.395,2.915,0.714,4.15,1.006c1.348,0.318,2.805,0.656,4.322,0.972l0.432,0.092
	L115.022,172.284z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="M69.128,153.137
	c-5.888,25.518-12.65,56.291-13.171,61.508c0.014,3.17,0.273,3.974,0.669,4.691c1.159,1.312,11.091,8.696,13.325,9.563
	c0.412,0.159,0.862,0.288,1.406,0.442c0.815,0.23,4.432,1.08,6.172,1.488c1.017,0.24,1.764,0.415,2.125,0.504
	c1.211,0.295,2.488,0.595,4.016,0.944l0.559,0.127c0.942,0.214,1.923,0.434,2.925,0.655c0.249,0.055,0.499,0.111,0.748,0.167
	c1.215,0.276,2.438,0.573,3.635,0.882c1.539,0.399,2.949,0.756,4.311,1.093c1.139,0.282,2.494,0.613,3.895,0.931
	c0.195,0.045,0.391,0.088,0.588,0.132l0.387,0.086c0.849,0.191,1.723,0.386,2.536,0.47c2.422,0.25,14.815-1.853,16.464-2.511
	c0.685-0.469,1.28-1.083,2.69-3.972c1.901-5.272,9.035-38.558,13.787-61.641"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	77.73,129.875 76.745,130.984 77.131,129.747 76.147,130.857 76.532,129.62 75.548,130.729 75.933,129.492 74.95,130.6 
	75.334,129.365 74.352,130.473 74.736,129.237 73.754,130.345 74.138,129.108 73.157,130.217 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	143.148,143.758 142.092,144.876 142.527,143.626 141.473,144.743 141.906,143.493 140.852,144.611 141.285,143.361 
	140.232,144.478 140.665,143.228 139.613,144.345 140.046,143.096 138.993,144.213 139.426,142.964 138.374,144.081 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="M45.219,105.117
	c1.138,1.059,2.21,2.145,3.214,3.264c9.961,11.104,6.246,37.172,3.277,53.419c-0.73,3.998-1.686,8.524-2.905,13.692"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="M44.928,107.263
	c0.817,0.762,1.598,1.541,2.342,2.338c10.048,10.766,6,37.15,2.805,53.641c-0.419,2.166-0.906,4.481-1.466,6.963"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M86.07,243.28
	c0,0,27.821,6.719,54.252,7.593"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M85.432,245.079
	c0,0,27.821,6.719,54.251,7.594"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
	M176.973,239.874c0,0,24.401-0.289,48.64-5.144"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M177.403,241.81
	c0,0,24.304-0.331,48.754-5.323"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="M68.493,344.347
	c0,0,30.63,5.524,59.428,5.27"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="M67.897,346.171
	c0,0,30.63,5.524,59.428,5.27"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="M188.376,335.18
	c0,0,20.716,1.252,44.368-0.379"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="M188.59,337.009
	c0,0,20.321,1.317,44.101-0.349"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M146.933,78.712
	c0,0.001,0.005-0.211,0.016-0.602"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="146.98"
        y1="76.935"
        x2="146.98"
        y2="76.935"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.176"
        d="M146.98,76.935
	c0.155-5.895,0.648-24.633,0.743-28.235"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M147.722,48.699
	c0.01-0.389,0.016-0.602,0.016-0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M144.658,78.359
	c0,0.001,0.006-0.211,0.018-0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="144.71"
        y1="76.569"
        x2="144.71"
        y2="76.568"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        d="M144.71,76.568
	c0.173-5.957,0.724-24.933,0.83-28.559"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M145.54,48.009
	c0.011-0.389,0.017-0.601,0.017-0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="136.007"
        y1="44.736"
        x2="135.99"
        y2="45.338"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="135.956"
        y1="46.575"
        x2="135.956"
        y2="46.576"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.238,1.237"
        x1="135.956"
        y1="46.576"
        x2="135.124"
        y2="76.276"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="135.124"
        y1="76.276"
        x2="135.107"
        y2="76.878"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="138.409"
        y1="45.492"
        x2="138.394"
        y2="46.094"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="138.363"
        y1="47.315"
        x2="138.363"
        y2="47.316"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        x1="138.363"
        y1="47.317"
        x2="137.625"
        y2="76.664"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="137.624"
        y1="76.664"
        x2="137.609"
        y2="77.266"
      />
      <path
        d="M136.833,45.697l-0.464,0.497l0.143-0.509c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.075,0.012
	l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.069c-0.024-0.014-0.055-0.01-0.074,0.011l-0.464,0.497l0.143-0.509
	c0.007-0.027-0.005-0.056-0.029-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.635,0.681l0.089,0.083l0.464-0.497l-0.143,0.508
	c-0.007,0.028,0.004,0.057,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.51
	c-0.008,0.027,0.004,0.055,0.029,0.069c0.024,0.014,0.055,0.009,0.074-0.011l0.464-0.498l-0.142,0.51
	c-0.008,0.026,0.003,0.055,0.028,0.069c0.006,0.004,0.013,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
	L136.833,45.697z"
      />
      <path
        d="M139.2,46.342l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
	l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
	c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
	c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
	c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
	c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.041-0.003,0.055-0.018l0.635-0.681
	L139.2,46.342z"
      />
      <path
        d="M135.973,75.386l-0.464,0.498l0.143-0.51c0.008-0.027-0.005-0.055-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011
	l-0.465,0.498l0.143-0.51c0.008-0.026-0.004-0.055-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
	c0.007-0.028-0.005-0.056-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.012l-0.636,0.68l0.089,0.083l0.465-0.497l-0.144,0.509
	c-0.007,0.027,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.509
	c-0.008,0.027,0.004,0.055,0.029,0.07c0.024,0.013,0.055,0.008,0.074-0.012l0.465-0.497l-0.143,0.509
	c-0.008,0.027,0.004,0.056,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.04-0.003,0.055-0.018l0.635-0.681
	L135.973,75.386z"
      />
      <path
        d="M138.447,75.708l-0.464,0.498l0.143-0.51c0.008-0.027-0.005-0.055-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011
	l-0.465,0.497l0.143-0.509c0.008-0.026-0.004-0.055-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
	c0.007-0.028-0.005-0.056-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.012l-0.636,0.68l0.089,0.083l0.465-0.497l-0.144,0.509
	c-0.007,0.027,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.509
	c-0.008,0.027,0.004,0.055,0.029,0.07c0.024,0.013,0.055,0.008,0.074-0.012l0.465-0.497l-0.143,0.509
	c-0.008,0.027,0.004,0.056,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.04-0.003,0.055-0.018l0.635-0.681
	L138.447,75.708z"
      />
      <path
        d="M145.546,76.892l-0.464,0.497l0.143-0.509c0.008-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
	l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
	c0.007-0.027-0.005-0.056-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
	c-0.007,0.028,0.005,0.057,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.509
	c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.51
	c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
	L145.546,76.892z"
      />
      <path
        d="M147.698,77.215l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
	l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.015-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
	c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
	c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
	c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
	c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
	L147.698,77.215z"
      />
      <path
        d="M146.299,48.278l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.055-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012
	l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
	c0.007-0.028-0.005-0.057-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.011l-0.636,0.681l0.089,0.083l0.465-0.497l-0.144,0.509
	c-0.007,0.027,0.005,0.056,0.029,0.069c0.025,0.014,0.055,0.01,0.075-0.011l0.464-0.498l-0.143,0.51
	c-0.008,0.027,0.004,0.055,0.029,0.069c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.497l-0.143,0.509
	c-0.008,0.027,0.004,0.055,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.041-0.003,0.055-0.018l0.635-0.681
	L146.299,48.278z"
      />
      <path
        d="M148.451,48.816l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
	l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.015-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
	c0.007-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
	c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
	c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
	c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.041-0.003,0.055-0.018l0.635-0.681
	L148.451,48.816z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="168.045"
        y1="55.822"
        x2="167.476"
        y2="55.625"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="166.44"
        y1="55.266"
        x2="166.439"
        y2="55.266"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.096,1.095"
        x1="166.439"
        y1="55.266"
        x2="160.223"
        y2="53.114"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="160.223,53.114 159.654,52.917 
	159.643,53.519 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="159.623"
        y1="54.642"
        x2="159.623"
        y2="54.643"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.124,1.123"
        x1="159.623"
        y1="54.643"
        x2="159.375"
        y2="68.128"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="159.374,68.128 159.363,68.73 
	159.942,68.896 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="161.016"
        y1="69.203"
        x2="161.017"
        y2="69.203"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.118,1.117"
        x1="161.017"
        y1="69.204"
        x2="167.466"
        y2="71.051"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="167.466"
        y1="71.05"
        x2="168.045"
        y2="71.216"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="159.363"
        y1="68.73"
        x2="168.045"
        y2="63.758"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="159.654"
        y1="52.917"
        x2="168.045"
        y2="62.706"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="158.651"
        y1="52.507"
        x2="148.662"
        y2="49.555"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="158.27"
        y1="68.507"
        x2="148.255"
        y2="65.764"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M134.388,62.611
	c0,0-26.718-7.863-33.897-8.295l-2.366-0.108"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M134.889,45.492
	c0,0-28.174-7.181-32.9-9.129l-2.013-0.69"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M82.419,53.132
	c0,0-16.117-0.019-20.375,1.55"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M84.57,31.618
	c0,0-8.896-2.344-14.667-2.893"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M95.494,65.331c0,0.001,0.024-0.21,0.068-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="95.7"
        y1="63.521"
        x2="95.7"
        y2="63.52"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.221,1.22"
        d="M95.7,63.52
	c0.691-6.06,2.903-25.459,3.32-29.118"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M99.021,34.4
	c0.044-0.387,0.068-0.598,0.068-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M93.004,64.889c0,0.001,0.024-0.21,0.069-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="93.213"
        y1="63.065"
        x2="93.213"
        y2="63.064"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.235"
        d="M93.213,63.064
	c0.703-6.126,2.958-25.778,3.381-29.463"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M96.594,33.6
	c0.044-0.387,0.068-0.598,0.068-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="86.007"
        y1="29.87"
        x2="85.945"
        y2="30.469"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="85.822"
        y1="31.652"
        x2="85.822"
        y2="31.653"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="85.822"
        y1="31.653"
        x2="82.624"
        y2="62.439"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="82.624"
        y1="62.439"
        x2="82.562"
        y2="63.038"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="88.481"
        y1="30.623"
        x2="88.419"
        y2="31.222"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="88.296"
        y1="32.405"
        x2="88.296"
        y2="32.406"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="88.296"
        y1="32.406"
        x2="85.098"
        y2="63.192"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="85.098"
        y1="63.192"
        x2="85.036"
        y2="63.791"
      />
      <path
        d="M86.935,30.87l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.056-0.022-0.071c-0.023-0.016-0.054-0.014-0.075,0.004
	l-0.508,0.452L86.2,30.72c0.01-0.027,0.001-0.056-0.022-0.072s-0.055-0.014-0.076,0.004l-0.508,0.452l0.19-0.493
	c0.01-0.027,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.695,0.619l0.081,0.091l0.508-0.452l-0.189,0.494
	c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.005l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.055,0.022,0.071
	s0.054,0.015,0.075-0.004l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.055,0.023,0.071c0.005,0.005,0.012,0.008,0.019,0.009
	c0.019,0.006,0.04,0.001,0.056-0.013l0.695-0.619L86.935,30.87z"
      />
      <path
        d="M89.409,31.73l-0.508,0.452l0.189-0.493c0.01-0.026,0.001-0.056-0.022-0.072c-0.023-0.016-0.054-0.014-0.075,0.004
	l-0.508,0.452l0.189-0.493c0.01-0.026,0.001-0.056-0.022-0.072s-0.055-0.014-0.076,0.004l-0.508,0.453l0.19-0.494
	c0.01-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.005l-0.695,0.618l0.081,0.092l0.508-0.453l-0.189,0.494
	c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.004l0.508-0.453l-0.189,0.494c-0.01,0.026-0.001,0.056,0.022,0.072
	s0.054,0.014,0.075-0.005l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.056,0.023,0.072c0.005,0.004,0.012,0.007,0.019,0.009
	c0.019,0.005,0.04,0,0.056-0.014l0.695-0.619L89.409,31.73z"
      />
      <path
        d="M83.481,61.588l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
	l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.074,0.009l-0.485,0.477l0.164-0.503
	c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.016-0.055-0.012-0.075,0.008l-0.663,0.653l0.086,0.087l0.484-0.477L81.96,62.09
	c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
	c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.164,0.503
	c-0.009,0.026,0.001,0.055,0.025,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.02,0.004,0.04-0.002,0.055-0.016l0.664-0.653
	L83.481,61.588z"
      />
      <path
        d="M86.278,62.018l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
	l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.074,0.009l-0.485,0.477l0.164-0.503
	c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
	c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
	c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
	c-0.008,0.027,0.002,0.055,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.02,0.004,0.04-0.001,0.055-0.016l0.663-0.653
	L86.278,62.018z"
      />
      <path
        d="M94.023,63.417l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
	l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.075,0.009l-0.484,0.477l0.164-0.503
	c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
	c-0.009,0.027,0.002,0.056,0.026,0.071c0.023,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
	c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
	c-0.008,0.027,0.002,0.055,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.019,0.004,0.04-0.001,0.055-0.016l0.663-0.653
	L94.023,63.417z"
      />
      <path
        d="M96.498,63.847l-0.485,0.478l0.165-0.503c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.009
	l-0.485,0.477l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.014-0.054-0.011-0.075,0.009l-0.484,0.477l0.164-0.503
	c0.009-0.027-0.002-0.055-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
	c-0.009,0.027,0.002,0.056,0.026,0.071c0.023,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
	c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
	c-0.008,0.027,0.002,0.056,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.019,0.004,0.04-0.001,0.055-0.016l0.663-0.653
	L96.498,63.847z"
      />
      <path
        d="M97.477,34.097l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.055-0.022-0.071c-0.023-0.016-0.055-0.014-0.076,0.004
	l-0.508,0.452l0.19-0.493c0.01-0.027,0.001-0.056-0.022-0.072c-0.024-0.016-0.055-0.014-0.076,0.004l-0.508,0.452l0.19-0.493
	c0.009-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.695,0.619l0.081,0.091l0.508-0.452l-0.189,0.494
	c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494c-0.01,0.026-0.001,0.056,0.022,0.071
	c0.023,0.017,0.054,0.015,0.075-0.004l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.055,0.022,0.071
	c0.006,0.005,0.013,0.008,0.02,0.009c0.019,0.006,0.04,0.001,0.056-0.013l0.695-0.619L97.477,34.097z"
      />
      <path
        d="M99.843,34.85l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.055-0.022-0.071c-0.023-0.016-0.055-0.014-0.076,0.004
	l-0.508,0.452l0.19-0.493c0.01-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.508,0.452l0.189-0.493
	c0.01-0.026,0.001-0.056-0.022-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.696,0.619l0.081,0.091l0.509-0.452l-0.19,0.494
	c-0.01,0.026,0,0.056,0.023,0.072c0.022,0.016,0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494
	c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494c-0.01,0.026-0.001,0.056,0.022,0.071
	c0.006,0.005,0.013,0.008,0.02,0.01c0.019,0.005,0.04,0,0.055-0.014l0.696-0.619L99.843,34.85z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M85.915,242.42
	c0,0,28,6.547,54.43,7.422"
      />
      <path
        d="M306.545,30.188c0.41-0.056,0.832-0.114,1.262-0.173C307.376,30.073,306.955,30.131,306.545,30.188 M312.8,29.35
	c0.59-0.076,1.193-0.154,1.806-0.232C313.993,29.195,313.39,29.273,312.8,29.35"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M453.273,58.869c0.01,0.269-0.089,0.522-0.279,0.713c-0.189,0.191-0.441,0.289-0.711,0.282l-13.255-0.427
	c-0.309-0.01-0.559-0.261-0.567-0.571l-0.227-9.353l-0.013-0.611l-0.479-19.744c0.198,0.026,0.396,0.051,0.592,0.076
	c0.201,0.025,0.4,0.051,0.598,0.077c0.043,0.005,0.087,0.011,0.13,0.017c0.034,0.004,0.07,0.009,0.104,0.013
	c0.03,0.005,0.062,0.008,0.092,0.012c0.063,0.009,0.125,0.017,0.188,0.025c0.026,0.003,0.052,0.006,0.077,0.01
	c0.098,0.012,0.196,0.025,0.293,0.038h0.003c0.006,0.001,0.011,0.001,0.016,0.002c0.006,0.002,0.012,0.003,0.019,0.004
	c0.044,0.005,0.089,0.01,0.133,0.016c0.004,0.001,0.009,0.002,0.013,0.002c0.035,0.004,0.071,0.009,0.106,0.014
	c0.097,0.012,0.193,0.026,0.289,0.037c0.119,0.016,0.239,0.032,0.358,0.048c0.021,0.003,0.044,0.005,0.065,0.008
	c0.05,0.007,0.1,0.013,0.149,0.02c0.04,0.006,0.08,0.01,0.12,0.016c0.054,0.007,0.108,0.015,0.162,0.021
	c0.035,0.005,0.071,0.01,0.106,0.014c0.152,0.021,0.304,0.041,0.453,0.06c0.092,0.014,0.185,0.025,0.277,0.037
	c0.194,0.027,0.387,0.053,0.58,0.079c0.17,0.022,0.337,0.045,0.505,0.067c0.001,0,0.003,0.001,0.004,0.001
	c0.169,0.023,0.337,0.046,0.503,0.068c0.007,0.001,0.016,0.002,0.023,0.004c0.075,0.01,0.151,0.02,0.225,0.03
	c0.082,0.011,0.165,0.022,0.246,0.034c0.017,0.002,0.033,0.005,0.05,0.007c0.172,0.023,0.343,0.047,0.512,0.069
	c0.085,0.012,0.169,0.024,0.251,0.035c0.051,0.007,0.101,0.014,0.151,0.021c0.08,0.011,0.159,0.022,0.237,0.033
	c0.156,0.021,0.312,0.043,0.465,0.064c0.126,0.017,0.251,0.035,0.375,0.052c0.028,0.004,0.055,0.008,0.083,0.012
	c0.075,0.01,0.15,0.021,0.225,0.032c0.036,0.005,0.074,0.01,0.11,0.015l0.113,0.016c0.06,0.007,0.119,0.016,0.177,0.024
	c0.015,0.003,0.029,0.005,0.044,0.006c0.14,0.021,0.279,0.04,0.416,0.058c0.227,0.034,0.451,0.065,0.67,0.096
	c0.074,0.011,0.147,0.021,0.219,0.031c0.02,0.003,0.041,0.006,0.061,0.009c0.003,0,0.006,0.001,0.009,0.001
	c0.056,0.009,0.113,0.016,0.167,0.024c0.026,0.003,0.052,0.007,0.078,0.01c0.022,0.005,0.044,0.008,0.066,0.01
	c0.067,0.01,0.134,0.019,0.201,0.029c0.09,0.013,0.178,0.026,0.267,0.038c0.069,0.01,0.136,0.02,0.204,0.03
	c0.09,0.013,0.179,0.026,0.266,0.038c0.078,0.011,0.153,0.022,0.228,0.033c0.102,0.015,0.202,0.03,0.301,0.044
	c0.064,0.01,0.128,0.018,0.191,0.028c0.016,0.002,0.032,0.004,0.048,0.006c0.093,0.014,0.184,0.027,0.274,0.04
	c0.026,0.005,0.052,0.008,0.078,0.012c0.009,0.001,0.018,0.003,0.027,0.004c0.044,0.007,0.089,0.013,0.133,0.018
	c0.008,0.003,0.018,0.004,0.028,0.005c0.051,0.007,0.102,0.015,0.152,0.022c0.12,0.019,0.237,0.036,0.352,0.052
	c0.058,0.009,0.115,0.017,0.172,0.026c0.057,0.007,0.113,0.016,0.169,0.025c0.056,0.008,0.112,0.016,0.167,0.024
	c0.053,0.008,0.107,0.016,0.161,0.024c0.007,0.001,0.014,0.002,0.02,0.003c0.03,0.005,0.059,0.009,0.087,0.013
	c0.004,0.001,0.01,0.001,0.014,0.002l0.708,18.146l0.024,0.611L453.273,58.869z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M470.312,471.858
	c-4.793,0.819-9.526,2.325-14.367,2.541c-1.613,0.537-3.227,0.43-4.948,0.752h-1.076c-8.82,0.861-17.533,0.753-26.354,0.216
	c-1.399-0.108-2.797-0.216-4.195-0.323c-1.184-0.108-2.259-0.215-3.442-0.323c-3.013-0.538-5.809-0.861-8.821-1.398
	c-2.582-0.43-4.948-1.076-7.37-1.504"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M286.745,76.683
	c28.5-2.336,57.005-3.305,85.619-3.52c27.86-0.107,55.614,0.538,83.582,2.797h1.075c0.538,0.108,1.076,0.108,1.614,0.215
	c2.259,0.108,4.518,0.323,6.777,0.515"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M287.159,74.097
	c28.408-2.439,56.914-3.3,85.42-3.623c11.94-0.107,23.988,0.108,35.929,0.431c14.844,0.322,29.474,1.076,44.318,2.044
	c1.399,0.107,2.797,0.215,4.195,0.322c0.538,0.108,1.076,0.108,1.614,0.216c0.323,0,0.753-0.108,1.076,0
	c0.538,0.107,0.968,0.107,1.506,0.214c0.322,0,0.753-0.107,1.075,0c0.538,0.108,0.969,0.108,1.507,0.216
	c0.322,0,0.645,0,1.004,0.045"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="352.996"
        y1="25.06"
        x2="353.104"
        y2="25.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="353.321"
        y1="26.395"
        x2="353.321"
        y2="26.396"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="353.321"
        y1="26.396"
        x2="359.844"
        y2="53.133"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="359.844"
        y1="53.132"
        x2="359.952"
        y2="53.576"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="355.576"
        y1="25.06"
        x2="355.685"
        y2="25.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="355.901"
        y1="26.395"
        x2="355.901"
        y2="26.396"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="355.902"
        y1="26.396"
        x2="362.425"
        y2="53.133"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="362.425"
        y1="53.132"
        x2="362.533"
        y2="53.576"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="398.142"
        y1="25.06"
        x2="398.034"
        y2="25.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="397.817"
        y1="26.395"
        x2="397.817"
        y2="26.396"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="397.816"
        y1="26.396"
        x2="391.293"
        y2="53.133"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="391.293"
        y1="53.132"
        x2="391.185"
        y2="53.576"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="395.562"
        y1="25.06"
        x2="395.454"
        y2="25.504"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="395.236"
        y1="26.395"
        x2="395.236"
        y2="26.396"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="395.236"
        y1="26.396"
        x2="388.714"
        y2="53.133"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="388.713"
        y1="53.132"
        x2="388.605"
        y2="53.576"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M277.441,257.81
	c11.719-1.832,24.3-4.523,24.3-4.523c7.437-3.513,17.97-8.944,20.291-11.554c0.101-0.559,0.301-3.342-1.954-14.661
	c-1.545-7.756-3.965-18.24-7.192-31.16c-1.591-6.369-3.218-12.69-4.721-18.431c-2.277,3.058-8.28,8.368-13.078,11.02
	c-0.234,0.13-0.489,0.259-0.757,0.383c-3.567,1.652-10.494,2.451-15.681,2.761"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M279.915,155.906l21.063-2.343c2.055,10.363,3.604,19.572,3.572,21.258c-0.809,1.409-6.716,7.26-12.045,10.206
	c-0.155,0.086-0.324,0.171-0.503,0.254c-2.968,1.375-8.79,1.947-13.404,2.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M279.838,157.646l19.758-2.198c1.858,9.498,3.039,16.711,3.212,18.865c-1.253,1.566-6.298,6.535-11.135,9.209
	c-0.12,0.066-0.252,0.133-0.395,0.199c-2.44,1.13-7.571,1.749-12.604,2.016"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M474.505,257.81
	c-11.719-1.832-24.3-4.523-24.3-4.523c-7.437-3.513-17.969-8.944-20.291-11.554c-0.101-0.559-0.301-3.342,1.954-14.661
	c1.546-7.756,3.965-18.24,7.192-31.16c1.591-6.369,3.219-12.69,4.721-18.431c2.278,3.058,8.28,8.368,13.078,11.02
	c0.234,0.13,0.489,0.259,0.757,0.383c3.568,1.652,10.494,2.451,15.681,2.761"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M472.032,155.906l-21.063-2.343c-2.055,10.363-3.604,19.572-3.573,21.258c0.809,1.409,6.717,7.26,12.046,10.206
	c0.155,0.086,0.324,0.171,0.503,0.254c2.968,1.375,8.789,1.947,13.404,2.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M472.108,157.646l-19.757-2.198c-1.859,9.498-3.039,16.711-3.213,18.865c1.253,1.566,6.298,6.535,11.135,9.209
	c0.12,0.066,0.252,0.133,0.395,0.199c2.441,1.13,7.572,1.749,12.604,2.016"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M294.58,77.09
	l1.248,15.165c0.038,0.467,0.484,0.845,1.037,0.878l57.828,3.503c0.026,0.001,0.052,0.002,0.078,0.002
	c0.584,0,1.088-0.397,1.119-0.896l1.312-21.155"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M297.152,76.878
	l1.015,12.342c0.067,0.811,0.719,1.45,1.532,1.499l52.084,3.155c0.901,0.054,1.677-0.631,1.732-1.532l1.112-17.916"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M457.836,77.09
	l-1.247,15.165c-0.039,0.467-0.484,0.845-1.037,0.878l-57.828,3.503c-0.027,0.001-0.053,0.002-0.078,0.002
	c-0.584,0-1.088-0.397-1.119-0.896l-1.313-21.155"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M455.265,76.878
	L454.25,89.22c-0.067,0.811-0.72,1.45-1.532,1.499l-52.084,3.155c-0.902,0.054-1.677-0.631-1.732-1.532l-1.112-17.916"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M383.122,200.562c6.884,1.793,13.553-0.789,19.577-4.554c7.745-4.948,14.091-10.649,18.824-18.502
	c2.582-4.518,4.196-9.036,5.487-13.984c0-0.107,0.215-0.323,0.215-0.43c1.829-7.637,2.474-15.383,0-22.805
	c-0.323-0.753-0.538-1.614-0.861-2.367c-1.398-3.119-3.227-6.024-5.594-8.605c-0.967-0.86-1.721-1.829-2.689-2.69
	c-5.916-5.485-12.478-9.358-19.685-12.478c-0.215-0.107-0.323,0-0.538-0.107c-5.055-2.151-10.111-3.55-15.597-4.518
	c-2.905-0.43-5.487-0.968-8.391-0.646c-0.323,0.108-0.645,0.216-0.968,0.216c-16.351,2.044-31.626,8.821-42.813,21.299
	c-0.107,0.107-0.107,0.322-0.215,0.43c-6.669,7.422-7.853,17.534-6.347,27.108c0.646,3.442,1.291,6.777,2.474,10.004
	c1.076,3.011,2.152,5.916,3.766,8.712c4.625,8.176,11.187,13.985,19.147,19.256c0.323,0.215,0.538,0.215,0.86,0.43
	c1.722,1.183,3.443,1.936,5.271,2.797c0.861,0.43,1.829,0.645,2.69,0.968c3.657,1.075,7.53,1.398,11.136,0.412"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M383.378,198.959c1.317,0.355,2.702,0.535,4.118,0.535c5.519,0,11.822-2.689,18.733-7.993c7.547-5.792,12.846-12.042,15.749-18.576
	c3.575-8.046,10.508-28.268-2.287-42.237c-9.124-9.961-20.628-14.96-28.672-17.4c-7.669-2.326-13.733-2.831-15.125-2.921
	c-1.393,0.09-7.456,0.595-15.125,2.921c-8.044,2.44-19.548,7.439-28.672,17.4c-12.795,13.969-5.862,34.191-2.287,42.237
	c2.903,6.534,8.201,12.784,15.749,18.576c6.911,5.304,13.213,7.993,18.733,7.993c1.416,0,2.801-0.18,4.118-0.535"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M315.398,30.442
	c13.036-1.583,29.142-3.361,36.862-3.512"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M295.835,32.942
	c0,0,1.351-0.184,3.651-0.486"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="314.927"
        y1="47.57"
        x2="357.031"
        y2="46.261"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="294.58"
        y1="48.202"
        x2="298.879"
        y2="48.069"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M436.983,30.563
	c-13.201-1.612-29.939-3.478-37.858-3.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M455.551,32.942
	c0,0-0.911-0.124-2.509-0.335"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="437.429"
        y1="47.6"
        x2="394.355"
        y2="46.261"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="456.805"
        y1="48.202"
        x2="453.579"
        y2="48.102"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M381.835,194.132c0,0,1.469-29.314,1.114-32.625c-0.356-3.31-4.843-5.425-6.933-4.801h-0.091c-2.091-0.624-6.577,1.491-6.933,4.801
	c-0.356,3.311,1.114,32.625,1.114,32.625"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M281.581,471.911
	c8.277,1.95,16.775,3.133,25.273,3.671c15.167,0.861,30.442-0.323,45.327-3.699"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="377.174"
        y1="74.399"
        x2="377.174"
        y2="107.937"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="378.378"
        y1="74.399"
        x2="378.378"
        y2="107.937"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="379.755"
        y1="74.399"
        x2="379.755"
        y2="107.937"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M371.002,176.638v-12.386c0-1.592,0.593-3.144,1.717-4.272c0.772-0.776,1.743-1.195,3.146-1.21"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
	M381.026,176.747l-0.172-12.559c0-1.591-0.593-3.143-1.717-4.271c-0.772-0.775-1.743-1.195-3.146-1.21"
      />
      <path
        d="M354.55,26.022l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78L354.55,26.022
	z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M354.55,26.022l-0.37,0.571l0.052-0.526
	c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78L354.55,26.022
	z"
      />
      <path
        d="M356.786,26.022l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L356.786,26.022z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M356.786,26.022l-0.37,0.571l0.052-0.526
	c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L356.786,26.022z"
      />
      <path
        d="M396.008,26.022l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L396.008,26.022z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M396.008,26.022l-0.37,0.571l0.052-0.526
	c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L396.008,26.022z"
      />
      <path
        d="M398.244,26.022l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L398.244,26.022z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M398.244,26.022l-0.37,0.571l0.052-0.526
	c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
	L398.244,26.022z"
      />
      <path
        d="M389.815,51.654l-0.37,0.57l0.052-0.526c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571
	l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.506-0.781L389.815,51.654z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M389.815,51.654l-0.37,0.57l0.052-0.526
	c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064
	c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.063
	c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.055,0.04,0.064
	c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023
	l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028
	l0.506-0.781L389.815,51.654z"
      />
      <path
        d="M392.051,51.654l-0.37,0.57l0.052-0.526c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571
	l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
	c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.506-0.781L392.051,51.654z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M392.051,51.654l-0.37,0.57l0.052-0.526
	c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064
	c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.063
	c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.055,0.04,0.064
	c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023
	l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028
	l0.506-0.781L392.051,51.654z"
      />
      <path
        d="M360.915,51.654l-0.37,0.57l0.052-0.526c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.052-0.526c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L360.915,51.654z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M360.915,51.654l-0.37,0.57l0.052-0.526
	c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L360.915,51.654z"
      />
      <path
        d="M363.151,51.654l-0.37,0.57l0.052-0.526c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024
	l-0.37,0.571l0.052-0.526c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L363.151,51.654z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M363.151,51.654l-0.37,0.57l0.052-0.526
	c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.052-0.526
	c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
	c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
	c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
	c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
	c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L363.151,51.654z"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	454.682,153.176 453.483,154.599 453.827,153.08 452.628,154.503 452.972,152.984 451.774,154.407 452.118,152.888 450.919,154.311 
	451.263,152.792 450.064,154.215 450.408,152.696 449.209,154.119 449.553,152.599 448.355,154.023 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
	297.31,153.226 298.531,154.63 298.163,153.116 299.384,154.52 299.016,153.007 300.237,154.411 299.87,152.897 301.09,154.302 
	300.723,152.788 301.943,154.192 301.576,152.679 302.796,154.082 302.429,152.569 303.649,153.973 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="301.349"
        y1="30.671"
        x2="300.443"
        y2="60.161"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="304.092"
        y1="30.294"
        x2="303.133"
        y2="60.16"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="311.031"
        y1="29.449"
        x2="310.125"
        y2="60.16"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="313.773"
        y1="29.057"
        x2="312.814"
        y2="60.161"
      />
      <path
        d="M300.576,31.722l0.345,0.423l-0.052-0.413c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013
	l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.044,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
	c-0.003-0.022,0.012-0.045,0.037-0.054c0.024-0.009,0.051-0.004,0.065,0.014l0.475,0.58l-0.094,0.061l-0.347-0.425l0.053,0.415
	c0.002,0.021-0.013,0.044-0.037,0.053c-0.025,0.009-0.052,0.004-0.066-0.013l-0.347-0.425l0.052,0.414
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
	c0.002,0.022-0.013,0.044-0.037,0.054c-0.007,0.002-0.013,0.004-0.02,0.004c-0.018,0.002-0.036-0.005-0.046-0.018l-0.472-0.58
	L300.576,31.722z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M300.576,31.722l0.345,0.423l-0.052-0.413
	c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
	c-0.003-0.022,0.013-0.044,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
	c-0.003-0.022,0.012-0.045,0.037-0.054c0.024-0.009,0.051-0.004,0.065,0.014l0.475,0.58l-0.094,0.061l-0.347-0.425l0.053,0.415
	c0.002,0.021-0.013,0.044-0.037,0.053c-0.025,0.009-0.052,0.004-0.066-0.013l-0.347-0.425l0.052,0.414
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
	c0.002,0.022-0.013,0.044-0.037,0.054c-0.007,0.002-0.013,0.004-0.02,0.004c-0.018,0.002-0.036-0.005-0.046-0.018l-0.472-0.58
	L300.576,31.722z"
      />
      <path
        d="M303.265,31.291l0.345,0.424l-0.051-0.414c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.014
	l0.346,0.423l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.424l-0.052-0.414
	c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.052-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.004-0.066-0.014l-0.346-0.424l0.051,0.414
	c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
	c0.003,0.023-0.013,0.045-0.037,0.054c-0.007,0.003-0.013,0.004-0.019,0.005c-0.019,0.001-0.036-0.006-0.047-0.019l-0.472-0.58
	L303.265,31.291z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M303.265,31.291l0.345,0.424l-0.051-0.414
	c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.014l0.346,0.423l-0.052-0.414
	c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.424l-0.052-0.414
	c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.052-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.004-0.066-0.014l-0.346-0.424l0.051,0.414
	c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
	c0.003,0.023-0.013,0.045-0.037,0.054c-0.007,0.003-0.013,0.004-0.019,0.005c-0.019,0.001-0.036-0.006-0.047-0.019l-0.472-0.58
	L303.265,31.291z"
      />
      <path
        d="M310.257,30.538l0.345,0.424l-0.052-0.414c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013
	l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.423l-0.052-0.413
	c-0.003-0.022,0.012-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
	c0.002,0.022-0.013,0.044-0.037,0.054c-0.025,0.009-0.052,0.003-0.066-0.014l-0.346-0.424l0.051,0.414
	c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
	c0.002,0.023-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
	L310.257,30.538z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M310.257,30.538l0.345,0.424l-0.052-0.414
	c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
	c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.423l-0.052-0.413
	c-0.003-0.022,0.012-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
	c0.002,0.022-0.013,0.044-0.037,0.054c-0.025,0.009-0.052,0.003-0.066-0.014l-0.346-0.424l0.051,0.414
	c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
	c0.002,0.023-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
	L310.257,30.538z"
      />
      <path
        d="M312.839,30.108l0.345,0.424l-0.051-0.414c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.013
	l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
	c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.425l0.052,0.415
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.003-0.066-0.014l-0.346-0.425l0.051,0.414
	c0.003,0.023-0.012,0.045-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
	c0.003,0.022-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
	L312.839,30.108z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M312.839,30.108l0.345,0.424l-0.051-0.414
	c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
	c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
	c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.425l0.052,0.415
	c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.003-0.066-0.014l-0.346-0.425l0.051,0.414
	c0.003,0.023-0.012,0.045-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
	c0.003,0.022-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
	L312.839,30.108z"
      />
      <path
        d="M299.81,58.712l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019l0.314,0.447
	l-0.021-0.416c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
	c-0.001-0.023,0.016-0.043,0.041-0.051s0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.314-0.449l0.021,0.417
	c0.002,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
	c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.064-0.018l-0.314-0.449l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.428-0.613
	L299.81,58.712z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M299.81,58.712l0.312,0.448l-0.02-0.416
	c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019l0.314,0.447l-0.021-0.416
	c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
	c-0.001-0.023,0.016-0.043,0.041-0.051s0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.314-0.449l0.021,0.417
	c0.002,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
	c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.064-0.018l-0.314-0.449l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.428-0.613
	L299.81,58.712z"
      />
      <path
        d="M302.176,58.712l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.051,0,0.064,0.019
	l0.313,0.447l-0.021-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
	c-0.001-0.023,0.016-0.043,0.041-0.051s0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.315-0.449l0.022,0.417
	c0.001,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
	c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.065-0.018l-0.313-0.449l0.021,0.417
	c0.001,0.022-0.017,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.429-0.613
	L302.176,58.712z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M302.176,58.712l0.312,0.448l-0.02-0.416
	c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.051,0,0.064,0.019l0.313,0.447l-0.021-0.416
	c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
	c-0.001-0.023,0.016-0.043,0.041-0.051s0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.315-0.449l0.022,0.417
	c0.001,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
	c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.065-0.018l-0.313-0.449l0.021,0.417
	c0.001,0.022-0.017,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.429-0.613
	L302.176,58.712z"
      />
      <path
        d="M309.491,58.39l0.313,0.448l-0.021-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019
	l0.314,0.448l-0.021-0.417c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
	c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.314-0.449l0.021,0.416
	c0.001,0.023-0.016,0.044-0.041,0.052c-0.024,0.007-0.051-0.001-0.064-0.019l-0.314-0.449l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.003-0.02,0.003c-0.018,0-0.036-0.008-0.045-0.022l-0.428-0.613
	L309.491,58.39z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M309.491,58.39l0.313,0.448l-0.021-0.416
	c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019l0.314,0.448l-0.021-0.417
	c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
	c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.314-0.449l0.021,0.416
	c0.001,0.023-0.016,0.044-0.041,0.052c-0.024,0.007-0.051-0.001-0.064-0.019l-0.314-0.449l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.003-0.02,0.003c-0.018,0-0.036-0.008-0.045-0.022l-0.428-0.613
	L309.491,58.39z"
      />
      <path
        d="M311.965,58.282l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051s0.052,0,0.064,0.019l0.314,0.447
	l-0.021-0.416c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
	c-0.002-0.023,0.016-0.044,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.019l-0.314-0.449l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.024,0.007-0.051,0-0.064-0.018L312.38,58.5l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.002-0.02,0.002c-0.018,0-0.036-0.007-0.045-0.021l-0.428-0.613
	L311.965,58.282z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M311.965,58.282l0.312,0.448l-0.02-0.416
	c-0.001-0.022,0.016-0.043,0.041-0.051s0.052,0,0.064,0.019l0.314,0.447l-0.021-0.416c-0.001-0.022,0.016-0.043,0.04-0.051
	c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416c-0.002-0.023,0.016-0.044,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019
	l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.019
	l-0.314-0.449l0.021,0.417c0.001,0.022-0.016,0.043-0.041,0.051c-0.024,0.007-0.051,0-0.064-0.018L312.38,58.5l0.021,0.417
	c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.002-0.02,0.002c-0.018,0-0.036-0.007-0.045-0.021l-0.428-0.613
	L311.965,58.282z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="451.308"
        y1="30.671"
        x2="452.214"
        y2="60.161"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="448.565"
        y1="30.294"
        x2="449.524"
        y2="60.16"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="441.626"
        y1="29.449"
        x2="442.532"
        y2="60.16"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="438.883"
        y1="29.057"
        x2="439.843"
        y2="60.161"
      />
      <path
        d="M452.081,31.722l-0.345,0.423l0.052-0.413c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
	l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.044-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
	c0.003-0.022-0.013-0.045-0.037-0.054c-0.024-0.009-0.051-0.004-0.066,0.014l-0.475,0.58l0.095,0.061l0.346-0.425l-0.052,0.415
	c-0.003,0.021,0.013,0.044,0.037,0.053c0.025,0.009,0.052,0.004,0.066-0.013l0.346-0.425l-0.051,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
	c-0.003,0.022,0.013,0.044,0.037,0.054c0.007,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
	L452.081,31.722z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M452.081,31.722l-0.345,0.423l0.052-0.413
	c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
	c0.003-0.022-0.013-0.044-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
	c0.003-0.022-0.013-0.045-0.037-0.054c-0.024-0.009-0.051-0.004-0.066,0.014l-0.475,0.58l0.095,0.061l0.346-0.425l-0.052,0.415
	c-0.003,0.021,0.013,0.044,0.037,0.053c0.025,0.009,0.052,0.004,0.066-0.013l0.346-0.425l-0.051,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
	c-0.003,0.022,0.013,0.044,0.037,0.054c0.007,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
	L452.081,31.722z"
      />
      <path
        d="M449.392,31.291l-0.345,0.424l0.052-0.414c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.014
	l-0.346,0.423l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.014l-0.346,0.424l0.052-0.414
	c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.004,0.066-0.014l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
	c-0.002,0.023,0.013,0.045,0.037,0.054c0.007,0.003,0.013,0.004,0.02,0.005c0.018,0.001,0.036-0.006,0.046-0.019l0.472-0.58
	L449.392,31.291z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M449.392,31.291l-0.345,0.424l0.052-0.414
	c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.014l-0.346,0.423l0.052-0.414
	c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.014l-0.346,0.424l0.052-0.414
	c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.004,0.066-0.014l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
	c-0.002,0.023,0.013,0.045,0.037,0.054c0.007,0.003,0.013,0.004,0.02,0.005c0.018,0.001,0.036-0.006,0.046-0.019l0.472-0.58
	L449.392,31.291z"
      />
      <path
        d="M442.4,30.538l-0.345,0.424l0.051-0.414c0.003-0.022-0.012-0.044-0.037-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
	l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.025-0.01-0.052-0.004-0.066,0.014l-0.346,0.423l0.052-0.413
	c0.003-0.022-0.013-0.044-0.037-0.054c-0.024-0.009-0.052-0.003-0.066,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.052,0.003,0.066-0.014l0.346-0.424l-0.051,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
	c-0.003,0.023,0.012,0.045,0.037,0.054c0.006,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
	L442.4,30.538z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M442.4,30.538l-0.345,0.424l0.051-0.414
	c0.003-0.022-0.012-0.044-0.037-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
	c0.003-0.022-0.013-0.043-0.037-0.053c-0.025-0.01-0.052-0.004-0.066,0.014l-0.346,0.423l0.052-0.413
	c0.003-0.022-0.013-0.044-0.037-0.054c-0.024-0.009-0.052-0.003-0.066,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.052,0.003,0.066-0.014l0.346-0.424l-0.051,0.414
	c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
	c-0.003,0.023,0.012,0.045,0.037,0.054c0.006,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
	L442.4,30.538z"
      />
      <path
        d="M439.818,30.108l-0.345,0.424l0.052-0.414c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
	l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.051-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
	c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.425l-0.052,0.415
	c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.003,0.067-0.014l0.346-0.425l-0.052,0.414
	c-0.003,0.023,0.012,0.045,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
	c-0.002,0.022,0.013,0.045,0.037,0.054c0.007,0.002,0.013,0.004,0.02,0.004c0.018,0.002,0.036-0.005,0.046-0.018l0.472-0.58
	L439.818,30.108z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M439.818,30.108l-0.345,0.424l0.052-0.414
	c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
	c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.051-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
	c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.425l-0.052,0.415
	c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.003,0.067-0.014l0.346-0.425l-0.052,0.414
	c-0.003,0.023,0.012,0.045,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
	c-0.002,0.022,0.013,0.045,0.037,0.054c0.007,0.002,0.013,0.004,0.02,0.004c0.018,0.002,0.036-0.005,0.046-0.018l0.472-0.58
	L439.818,30.108z"
      />
      <path
        d="M452.848,58.712l-0.313,0.448l0.021-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019
	l-0.313,0.447l0.021-0.416c0.001-0.022-0.016-0.043-0.04-0.051c-0.026-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
	c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.051c0.024,0.008,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
	L452.848,58.712z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M452.848,58.712l-0.313,0.448l0.021-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.313,0.447l0.021-0.416
	c0.001-0.022-0.016-0.043-0.04-0.051c-0.026-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
	c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.051c0.024,0.008,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
	L452.848,58.712z"
      />
      <path
        d="M450.481,58.712l-0.312,0.448l0.02-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019
	l-0.314,0.447l0.021-0.416c0.002-0.022-0.016-0.043-0.04-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
	c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.021,0.417
	c-0.002,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.051c0.025,0.008,0.052,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.014,0.002,0.02,0.002c0.019,0,0.036-0.007,0.045-0.021l0.428-0.613
	L450.481,58.712z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M450.481,58.712l-0.312,0.448l0.02-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.447l0.021-0.416
	c0.002-0.022-0.016-0.043-0.04-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
	c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.021,0.417
	c-0.002,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.051c0.025,0.008,0.052,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.014,0.002,0.02,0.002c0.019,0,0.036-0.007,0.045-0.021l0.428-0.613
	L450.481,58.712z"
      />
      <path
        d="M443.166,58.39l-0.312,0.448l0.02-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.051,0-0.064,0.019
	l-0.314,0.448l0.022-0.417c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.022-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.431,0.613l0.099,0.054l0.315-0.449l-0.022,0.417
	c-0.001,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.315-0.449l-0.022,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.052c0.025,0.007,0.052-0.001,0.065-0.019l0.313-0.449l-0.021,0.417
	c-0.001,0.022,0.017,0.043,0.041,0.051c0.007,0.001,0.014,0.003,0.02,0.003c0.019,0,0.036-0.008,0.045-0.022l0.429-0.613
	L443.166,58.39z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M443.166,58.39l-0.312,0.448l0.02-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.051,0-0.064,0.019l-0.314,0.448l0.022-0.417
	c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.022-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.431,0.613l0.099,0.054l0.315-0.449l-0.022,0.417
	c-0.001,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.315-0.449l-0.022,0.416
	c-0.001,0.023,0.016,0.044,0.041,0.052c0.025,0.007,0.052-0.001,0.065-0.019l0.313-0.449l-0.021,0.417
	c-0.001,0.022,0.017,0.043,0.041,0.051c0.007,0.001,0.014,0.003,0.02,0.003c0.019,0,0.036-0.008,0.045-0.022l0.429-0.613
	L443.166,58.39z"
      />
      <path
        d="M440.692,58.282l-0.313,0.448l0.021-0.416c0-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.313,0.447l0.021-0.416
	c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.448l0.021-0.416
	c0.001-0.023-0.016-0.044-0.04-0.051c-0.026-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.019l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.024,0.007,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.006,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
	L440.692,58.282z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M440.692,58.282l-0.313,0.448l0.021-0.416
	c0-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.313,0.447l0.021-0.416c0.001-0.022-0.016-0.043-0.041-0.051
	c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.448l0.021-0.416c0.001-0.023-0.016-0.044-0.04-0.051c-0.026-0.008-0.052,0-0.065,0.019
	l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.019
	l0.314-0.449l-0.021,0.417c-0.001,0.022,0.016,0.043,0.041,0.051c0.024,0.007,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
	c-0.001,0.022,0.016,0.043,0.041,0.051c0.006,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
	L440.692,58.282z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M-364.335,431.135c0,0-0.204,0.041-0.591,0.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="-366.13"
        y1="431.456"
        x2="-366.13"
        y2="431.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        d="
	M-366.13,431.456c-6.555,1.096-29.785,4.315-48.526-1.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M-414.658,430.079
	c-0.192-0.059-0.384-0.118-0.575-0.178"
      />
      <path d="M-760.29,179.451c-0.043,0.343-0.065,0.528-0.065,0.528L-760.29,179.451z" />
      <path
        d="M-955.45-42.572c-0.418-4.527-1.522-9.09-2.59-13.503l-0.143-0.593c-1.076-4.452-2.341-9.02-3.867-13.969
	c-1.444-4.679-3.04-9.437-4.882-14.546c-1.708-4.739-3.613-9.729-5.664-14.829c-1.918-4.77-4.011-9.756-6.219-14.818
	c-2.05-4.701-4.252-9.584-6.541-14.512c-2.109-4.535-4.341-9.216-6.635-13.91c-2.087-4.269-4.273-8.648-6.499-13.015
	c-1.989-3.906-4.052-7.883-6.129-11.822c-1.819-3.45-3.681-6.928-5.532-10.336c-1.568-2.886-3.15-5.763-4.704-8.555
	c-1.243-2.232-2.471-4.411-3.646-6.475c-0.856-1.504-1.626-2.845-2.357-4.103c-0.262-0.454-0.527-0.907-0.792-1.359l0.006-0.193
	c0.457-14.758,0.952-33.136,1.029-36.035l0.011,0.003v-17.964c0-0.366-0.229-0.699-0.57-0.828
	c-5.669-2.155-12.868-4.358-19.22-6.301c-2.226-0.682-4.327-1.325-6.284-1.94c-4.297-1.361-8.657-2.663-12.964-3.871
	c-10.728-2.682-20.354-5.45-29.43-8.46c-4.55-1.51-9.564-3.086-14.857-4.415l-0.008-0.003l-0.483-0.147l-0.003,0.027
	c-4.392-1.088-8.971-1.999-13.633-2.556c-0.074-0.01-0.148-0.008-0.217,0.003h-0.02c-0.203-0.003-0.409-0.003-0.609-0.002
	c-0.765,3.724-2.379,10.645-2.379,10.645c-0.873,6.943-7.144,19.822-8.97,23.461c-4.711,9.329-8.369,19.006-10.876,28.83
	c-2.367,9.266-3.74,18.732-4.082,28.134c-0.607,16.694,2.231,28.545,3.115,31.779c0.214,0.785,0.361,1.595,0.437,2.408
	c0.407,4.337,1.343,16.35,1.257,34.176c-0.074,15.362,1.968,32.312,3.457,44.689c0.676,5.606,1.259,10.448,1.493,13.852
	c0.534,7.791-0.732,17.027-1.657,23.771c-0.372,2.714-0.693,5.059-0.818,6.736c-0.271,3.664-0.164,16.161-0.028,26
	c0.077,5.47-0.596,10.921-1.996,16.203c-2.567,9.682-5.999,23.56-7.761,34.684c-2.767,17.447-7.059,58.657-7.101,59.065
	c-0.067,0.527-6.676,52.821-7.102,61.446l-0.011,0.219l0.206,0.08c6.124,2.37,12.316,4.298,18.505,5.779
	c0.383,0.092,0.767,0.176,1.15,0.264c-0.021,0.168-0.032,0.263-0.032,0.263l0.033-0.263c3.015,0.694,6.028,1.293,9.031,1.768
	c6.443,1.02,12.837,1.533,19.058,1.533c1.217,0,2.428-0.02,3.632-0.058c12.36-0.406,20.388-2.827,20.825-3.351
	c0.369-0.443,1.391-4.757,2.377-10.036c0.763-4.08,2.162-12.303,2.962-21.543c1.374-15.845,10.349-53.182,10.533-53.946
	c0.678-2.194,15.614-50.563,16.574-58.022c0.991-7.708,2.257-43.489,1.938-50.289c-0.268-5.718,2.88-19.882,3.885-24.228
	c6.397,3.008,7.941,9.351,7.99,9.567c0.063,0.356,2.177,12.357,3.544,27.397c1.39,15.285,2.997,17.793,3.065,17.893l0.011,0.016
	c0.029,0.037,2.94,3.846,2.947,9.579c-1.677,11.811,0.144,55.514,1.292,71.578c1.063,14.877,1.181,49.543,1.182,49.892l0.006,0.056
	c0.048,0.253,0.746,2.511,10.263,3.783c10.016,1.337,20.064,1.756,35.102,2.058c0.491,0.01,0.974,0.015,1.452,0.015
	c7.64,0,13.775-1.216,17.661-2.271c4.483-1.218,6.96-2.458,7.063-2.51l0.152-0.077l0.014-0.17c0.02-0.246,2.036-24.753,1.183-32.544
	c-0.9-8.209-0.891-28.081,0.964-37.666c0.068-0.349,0.116-0.701,0.155-0.998c0.261-2.007,0.372-4.062,0.479-6.048l0.012-0.223
	c0.188-3.468,0.306-6.884,0.397-9.77c0.116-3.676,0.217-7.604,0.315-12.359c0.089-4.292,0.167-8.879,0.24-14.025
	c0.067-4.64,0.125-9.471,0.179-14.771c0.046-4.692,0.087-9.465,0.124-14.592c0.03-4.368,0.057-8.907,0.079-13.491
	c0.019-3.814,0.033-7.672,0.046-11.467c0.004-1.562,0.008-3.124,0.011-4.686c0.002-0.752,0.013-1.515,0.023-2.256
	C-955.267-37.907-955.236-40.253-955.45-42.572z"
      />
      <path
        d="M233.475,265.521c-0.418-4.527-1.522-9.09-2.59-13.503l-0.143-0.593c-1.076-4.452-2.341-9.02-3.867-13.969
	c-1.444-4.679-3.04-9.437-4.882-14.546c-1.708-4.739-3.613-9.729-5.664-14.829c-1.918-4.77-4.011-9.756-6.219-14.818
	c-2.05-4.701-4.252-9.584-6.541-14.512c-2.109-4.535-4.341-9.216-6.635-13.91c-2.087-4.269-4.273-8.648-6.499-13.015
	c-1.989-3.906-4.052-7.883-6.129-11.822c-1.819-3.45-3.681-6.928-5.532-10.336c-1.568-2.886-3.15-5.763-4.704-8.555
	c-1.243-2.232-2.471-4.411-3.646-6.475c-0.856-1.504-1.626-2.845-2.357-4.103c-0.262-0.454-0.527-0.907-0.792-1.359l0.006-0.193
	c0.457-14.758,0.952-33.136,1.029-36.035l0.011,0.003V54.987c0-0.366-0.229-0.699-0.57-0.828c-5.669-2.155-12.868-4.358-19.22-6.301
	c-2.226-0.682-4.327-1.325-6.284-1.94c-4.297-1.361-8.657-2.663-12.964-3.871c-10.728-2.682-20.354-5.45-29.43-8.46
	c-4.55-1.51-9.564-3.086-14.857-4.415l-0.008-0.003l-0.483-0.147l-0.003,0.027c-4.392-1.088-8.971-1.999-13.633-2.556
	c-0.074-0.01-0.148-0.008-0.217,0.003h-0.02c-0.927-0.013-1.93,0.025-2.016,0.028l-1.751,0.005c-0.54,0-0.914,0.288-1.003,0.772
	c-3.203,17.587-8.952,29.116-9.01,29.231l-0.004,0.01c-0.042,0.09-0.375,0.919,0.677,2.246c0.063,0.089,0.471,0.639,1.404,1.294
	c-4.838,9.488-8.578,19.343-11.132,29.348c-2.367,9.266-3.74,18.732-4.082,28.134c-0.607,16.694,2.231,28.545,3.115,31.779
	c0.214,0.785,0.361,1.595,0.437,2.408c0.407,4.337,1.343,16.35,1.257,34.176c-0.074,15.362,1.968,32.312,3.457,44.689
	c0.676,5.606,1.259,10.448,1.493,13.852c0.534,7.791-0.732,17.027-1.657,23.771c-0.372,2.714-0.693,5.059-0.818,6.736
	c-0.271,3.664-0.164,16.161-0.028,26c0.077,5.47-0.596,10.921-1.996,16.203c-2.567,9.682-5.999,23.56-7.761,34.684
	c-2.767,17.447-7.059,58.657-7.101,59.065c-0.067,0.527-6.676,52.821-7.102,61.446L27,472.592l0.206,0.08
	c9.487,3.672,19.14,6.3,28.686,7.811c6.443,1.02,12.837,1.533,19.058,1.533c1.217,0,2.428-0.02,3.632-0.058
	c12.36-0.406,20.388-2.827,20.825-3.351c0.369-0.443,1.391-4.757,2.377-10.036c0.763-4.08,2.162-12.303,2.962-21.543
	c1.374-15.845,10.349-53.182,10.533-53.946c0.678-2.194,15.614-50.563,16.574-58.022c0.991-7.708,2.257-43.489,1.938-50.289
	c-0.268-5.718,2.88-19.882,3.885-24.228c6.397,3.008,7.941,9.351,7.99,9.567c0.063,0.356,2.177,12.357,3.544,27.397
	c1.39,15.285,2.997,17.793,3.065,17.893l0.011,0.016c0.029,0.037,2.94,3.846,2.947,9.579c-1.677,11.811,0.144,55.514,1.292,71.578
	c1.063,14.877,1.181,49.543,1.182,49.892l0.006,0.056c0.048,0.253,0.746,2.511,10.263,3.783c10.016,1.337,20.064,1.756,35.102,2.058
	c0.491,0.01,0.974,0.015,1.452,0.015c7.64,0,13.775-1.216,17.661-2.271c4.483-1.218,6.96-2.458,7.063-2.51l0.152-0.077l0.014-0.17
	c0.02-0.246,2.036-24.753,1.183-32.544c-0.9-8.209-0.891-28.081,0.964-37.666c0.068-0.349,0.116-0.701,0.155-0.998
	c0.261-2.007,0.372-4.062,0.479-6.048l0.012-0.223c0.188-3.468,0.306-6.884,0.397-9.77c0.116-3.676,0.217-7.604,0.315-12.359
	c0.089-4.292,0.167-8.879,0.24-14.025c0.067-4.64,0.125-9.471,0.179-14.771c0.046-4.692,0.087-9.465,0.124-14.592
	c0.03-4.368,0.057-8.907,0.079-13.491c0.019-3.814,0.033-7.672,0.046-11.467c0.004-1.562,0.008-3.124,0.011-4.686
	c0.002-0.752,0.013-1.515,0.023-2.256C233.658,270.186,233.689,267.84,233.475,265.521 M167.711,54.987v17.164
	c-1.101-0.302-4.466-1.223-9.159-2.487l0.392-17.918c3.036,0.986,5.978,1.989,8.591,2.983
	C167.641,54.769,167.711,54.873,167.711,54.987 M157.945,69.501c-2.777-0.747-5.986-1.605-9.445-2.521l0.462-18.352
	c3.036,0.928,6.247,1.913,9.376,2.923L157.945,69.501z M100.161,103.521l12.146-5.024c1.366-0.566,2.748-1.191,4.107-1.858
	c9.172-4.503,27.485-12.488,30.563-13.828l-0.674,19.873c-5.325,0.998-25.244,5.655-33.336,8.655l-13.927,4.847
	C99.433,111.803,99.807,107.571,100.161,103.521 M139.433,85.395l0.02,0.049c-7.021,3.097-17.191,7.645-23.308,10.648
	c-1.347,0.661-2.718,1.281-4.072,1.841l-11.852,4.902c2.216-25.352,3.645-43.402,3.854-46.059c6.744,1.25,18.41,4.099,29.942,7.056
	l-0.381,13.052l0.234,0.062c0.365,0.094,8.515,2.196,13.255,2.196c0.273,0,0.536-0.008,0.783-0.023
	c0.191-0.003,0.291-0.132,0.296-0.383l0.28-11.13c1.783,0.472,3.498,0.928,5.122,1.362l-0.026,0.535
	c-0.125,2.051-0.581,7.638-1.176,8.828c-0.18,0.363-0.441,0.734-0.773,1.102c-0.65,0.722-1.458,1.297-2.401,1.706L139.433,85.395z
	 M134.641,63.363l0.545-18.618l13.167,3.83c-0.039,1.556-0.263,10.489-0.458,18.245c-0.005,0.209-0.011,0.418-0.015,0.626
	c-0.134,5.29-0.251,9.913-0.28,11.078c-4.141,0.144-11.893-1.745-13.341-2.109l0.364-12.428L134.641,63.363z M134.593,44.212
	l-0.557,18.996c-11.693-2.998-23.509-5.879-30.185-7.093c-1.84-0.334-3.803-0.592-5.837-0.785l2.38-20.922
	c8.874,2.922,18.285,5.616,28.732,8.228C130.941,43.145,132.766,43.671,134.593,44.212 M97.338,55.881
	c-0.517,4.55-0.942,8.283-1.056,9.289c-4.602-0.003-13.093-2.213-14.655-2.63l0.735-7.053l0.064-0.611l2.61-25.055l14.753,4.498
	c-0.203,1.783-1.429,12.576-2.382,20.957C97.383,55.479,97.361,55.681,97.338,55.881 M81.81,54.89
	c-9.613,0.232-18.013,1.124-20.202,1.373c1.135-2.411,5.979-13.282,8.822-28.891c0.023-0.132,0.121-0.234,0.244-0.265
	c0.071,0.001,0.139,0.003,0.208,0.004c0.006,0,0.012,0.001,0.018,0.001c4.628,0.558,9.175,1.467,13.538,2.549L81.81,54.89z
	 M60.825,56.485c-0.001,0.003-0.004,0.005-0.005,0.008c-0.293,0.538-0.583,1.077-0.868,1.618c-0.571-0.84-0.42-1.325-0.412-1.352
	c0.189-0.375,5.24-10.553,8.415-27.989c0.032-0.174,0.193-0.293,0.366-0.273l0.02,0.002l1.258-0.003
	C66.397,45.193,61.002,56.127,60.825,56.485 M58.022,58.435l-0.013-0.02c-0.802-1.006-0.617-1.591-0.607-1.617
	c0.189-0.382,5.879-11.917,9.06-29.389c0.013-0.074,0.049-0.271,0.403-0.271l1.758-0.004h0.011c0.009,0,0.567-0.021,1.238-0.028
	c-0.019,0.049-0.033,0.102-0.042,0.156c-0.038,0.209-0.077,0.417-0.116,0.624l-1.34,0.003c-0.485-0.048-0.931,0.287-1.019,0.771
	c-3.202,17.586-8.312,27.731-8.363,27.832l-0.006,0.011c-0.041,0.089-0.369,0.904,0.65,2.209c-0.143,0.274-0.285,0.547-0.426,0.82
	C58.367,58.928,58.027,58.439,58.022,58.435 M61.285,56.915c1.274-0.151,10.164-1.162,20.462-1.415l-0.78,7.492l0.25,0.069
	c0.409,0.114,9.937,2.718,15.069,2.718c0.088,0,0.175,0,0.26-0.002c0.277,0.013,0.31-0.268,0.321-0.361l1.078-9.48
	c1.921,0.182,3.777,0.423,5.525,0.731l-2.923,34.907C84.853,85.275,55.14,79.306,51.666,78.62
	C54.221,71.255,57.43,64.01,61.285,56.915 M51.465,79.202c1.941,0.383,14.918,2.975,28.15,6.45l-0.298,1.203
	c-0.021,0.082-0.071,0.151-0.143,0.194c-0.072,0.043-0.157,0.054-0.238,0.034c-3.606-0.919-21.619-5.47-27.989-6.336
	C51.117,80.232,51.288,79.717,51.465,79.202 M50.755,81.337c6.229,0.82,24.408,5.415,28.031,6.338
	c0.076,0.019,0.152,0.027,0.229,0.027c0.164,0,0.327-0.044,0.472-0.13c0.212-0.128,0.363-0.33,0.422-0.571l0.296-1.194
	c2.837,0.752,5.679,1.541,8.419,2.359l-2.21,12.747c-0.17,0.548-0.756,0.892-1.367,0.803l-38.176-5.592
	C47.879,91.149,49.174,86.217,50.755,81.337 M47.417,149.183c-0.878-3.215-3.696-14.99-3.092-31.597
	c0.159-4.369,0.532-8.715,1.12-13.033c1.175,1.114,2.279,2.256,3.284,3.398c3.999,4.542,6.126,11.345,6.506,20.796
	c0.333,8.294-0.645,18.547-3.079,32.266c-0.777,4.377-1.789,9.229-3.083,14.774c-0.212-12.282-0.874-20.63-1.199-24.093
	C47.796,150.847,47.642,150.003,47.417,149.183 M34.719,410.997c0.043-0.414,4.334-41.608,7.097-59.04
	c1.76-11.099,5.185-24.954,7.748-34.623c1.416-5.336,2.094-10.842,2.017-16.368c-0.112-8.044-0.257-22.112,0.026-25.946
	c0.124-1.658,0.443-3.994,0.814-6.698c0.929-6.771,2.2-16.042,1.661-23.896c-0.235-3.419-0.818-8.269-1.495-13.883
	c-1.489-12.361-3.527-29.289-3.453-44.612c0.013-2.703,0.002-5.272-0.026-7.702l0.014,0.003c1.561-6.53,2.749-12.127,3.634-17.112
	c2.442-13.764,3.423-24.058,3.088-32.398c-0.385-9.596-2.562-16.523-6.656-21.174c-1.096-1.244-2.307-2.487-3.597-3.695
	l-0.057,0.061c0.338-2.406,0.745-4.803,1.217-7.191l38.208,5.596c0.095,0.014,0.188,0.021,0.281,0.021
	c0.809,0,1.539-0.511,1.764-1.27l0.005-0.016l2.203-12.712c4.152,1.25,8.049,2.559,11.316,3.881
	c-0.992,11.56-2.197,25.25-3.56,40.051c-0.445-0.093-0.863-0.181-1.246-0.263l-22.997-4.874l-0.089,0.383
	c-0.777,3.298-18.326,77.912-19.128,86.98l-0.002,0.039c0.011,3.801,0.348,5.024,1.097,6.333
	c0.811,1.419,12.026,9.584,14.466,10.531c0.526,0.204,1.07,0.358,1.597,0.507c0.825,0.236,3.966,0.977,6.262,1.518
	c0.977,0.23,1.749,0.414,2.101,0.498c1.217,0.298,2.502,0.602,4.043,0.956c1.034,0.236,2.12,0.481,3.235,0.729
	c-3.831,32.397-7.226,54.843-10.092,66.716c-5.931,24.557-13.052,71.258-17.981,106.111c-5.045,35.67-8.885,66.531-9.327,70.109
	c-6.577-1.41-13.72-3.454-21.275-6.364C28.152,462.949,34.652,411.526,34.719,410.997 M86.72,234.94
	c-1.204-0.267-2.377-0.532-3.491-0.786c-1.54-0.354-2.822-0.656-4.037-0.952c-0.355-0.087-1.127-0.27-2.107-0.5
	c-2.162-0.51-5.425-1.279-6.233-1.508c-0.519-0.146-1.049-0.298-1.55-0.491c-2.554-0.992-13.478-9.086-14.14-10.242
	c-0.676-1.183-0.981-2.321-0.993-5.922c0.794-8.773,17.629-80.435,19.048-86.466l0.107,0.023
	c-1.961,9.257-4.074,20.054-4.297,22.518l-0.002,0.04c-0.01,3.822,0.306,5.046,1.019,6.346c0.356,0.65,0.991,1.145,1.55,1.582
	c0.156,0.122,0.304,0.237,0.436,0.35c1.322,1.11,2.68,2.147,3.714,2.926c0.481,0.36,0.958,0.733,1.463,1.125
	c2.105,1.638,4.283,3.331,6.63,4.256c2.202,0.866,4.604,1.364,6.933,1.845c0.581,0.121,1.183,0.247,1.764,0.374
	c1.835,0.4,3.707,0.781,5.519,1.15c1.029,0.211,2.059,0.42,3.089,0.635c1.398,0.295,2.789,0.608,4.138,0.944
	c1.501,0.374,2.862,0.704,4.163,1.013c1.28,0.302,2.799,0.656,4.361,0.983l0.367,0.076c0.138,0.031,0.275,0.06,0.415,0.089
	c0.744,0.156,1.508,0.302,2.276,0.368c2.547,0.218,15.983-2.305,17.317-3.258c1.232-0.88,2.059-1.866,3.702-5.393l0.015-0.036
	c0.525-1.451,1.702-6.148,3.013-11.768c-4.629,22.792-14.38,70.122-16.863,76.791c-1.601,3.286-2.385,4.184-3.537,4.947
	c-1.123,0.748-14.755,3.024-17.521,2.736c-0.91-0.095-1.832-0.302-2.723-0.501l-0.384-0.087c-1.619-0.36-3.193-0.744-4.517-1.072
	c-1.353-0.337-2.765-0.695-4.322-1.1C89.635,235.611,88.181,235.262,86.72,234.94 M137.276,165.778
	c-1.558,3.344-2.318,4.263-3.432,5.059c-1.086,0.775-14.224,3.366-16.889,3.138c-0.875-0.075-1.762-0.264-2.621-0.445l-0.368-0.077
	c-1.556-0.325-3.071-0.678-4.346-0.98c-1.3-0.308-2.661-0.639-4.16-1.01c-1.357-0.337-2.755-0.657-4.161-0.949
	c-1.032-0.214-2.063-0.425-3.094-0.635c-1.812-0.369-3.681-0.748-5.513-1.149c-0.584-0.128-1.189-0.252-1.772-0.372
	c-2.303-0.477-4.683-0.97-6.841-1.819c-2.272-0.893-4.416-2.561-6.486-4.174c-0.509-0.394-0.989-0.768-1.474-1.132
	c-1.027-0.775-2.377-1.804-3.69-2.906c-0.141-0.12-0.292-0.238-0.452-0.363c-0.51-0.399-1.091-0.853-1.379-1.379
	c-0.648-1.181-0.935-2.32-0.925-5.948c0.227-2.439,2.373-13.382,4.289-22.405l18.749,3.976l50.065,10.689
	C140.709,152.413,138.127,163.404,137.276,165.778 M133.183,284.8c0.317,6.785-0.946,42.49-1.935,50.183
	c-0.308,2.403-2.138,9.275-4.477,17.485c-4.879,17.135-11.972,40.103-12.078,40.443l-0.005,0.018
	c-0.091,0.379-9.165,38.073-10.549,54.046c-1.388,16.011-4.666,30.307-5.19,31.224c-0.555,0.32-7.873,2.787-20.798,3.162
	c-7.18,0.207-17.012-0.249-28.645-2.688c0.41-3.319,4.262-34.306,9.332-70.15c2.654-18.76,5.941-40.953,9.337-61.273
	c2.91-17.417,5.898-33.456,8.633-44.78c2.668-11.054,5.793-31.237,9.296-60.051c0.265-2.176,0.532-4.401,0.801-6.675
	c1.339,0.299,2.671,0.621,3.961,0.956c1.557,0.405,2.973,0.766,4.327,1.101c1.156,0.286,2.5,0.616,3.9,0.936
	c0.208,0.047,0.419,0.093,0.629,0.14l0.383,0.086c0.909,0.204,1.847,0.415,2.793,0.514c2.643,0.275,16.572-1.924,17.952-2.84
	c1.274-0.845,2.127-1.807,3.815-5.276l0.015-0.037c3.256-8.676,18.652-85.385,19.33-88.773l0.077-0.384l-0.345-0.077l-28.048-5.947
	c-2.504-0.53-6.37-1.324-10.102-2.09c-2.828-0.58-5.726-1.174-8.024-1.653c0.492-5.343,0.964-10.542,1.413-15.547l14.193-4.94
	c8.195-3.039,28.56-7.782,33.48-8.675l0.241-0.042l0.703-20.683l1.874-0.814c1.025-0.445,1.904-1.07,2.611-1.858
	c0.37-0.41,0.661-0.826,0.867-1.238c0.772-1.544,1.22-8.757,1.239-9.067l0.019-0.406c7.12,1.903,12.352,3.337,13.497,3.651
	l-1.035,36.214c-0.271,8.726-0.528,16.178-0.679,18.396c-0.433,6.395-2.925,27.202-5.694,42.014l-20.509,80.366l-2.385,9.346
	l-0.018-0.004c-0.022,0.091-0.103,0.43-0.229,0.968c-0.001,0.004-0.002,0.009-0.003,0.014l-0.05,0.19l0.005,0.002
	C136.119,264.527,132.904,278.87,133.183,284.8 M189.792,451.392c-8.27-0.312-15.012-0.795-21.735-1.693
	c-8.555-1.143-9.642-3.063-9.74-3.285c-0.005-1.497-0.137-35.245-1.183-49.884c-1.147-16.055-2.97-59.733-1.294-71.469l0.003-0.044
	c0-5.84-2.84-9.667-3.066-9.963c-0.083-0.144-1.629-2.975-2.959-17.602c-1.383-15.219-3.531-27.336-3.553-27.456l-0.002-0.012
	c-0.016-0.072-0.403-1.788-1.666-3.906c-1.141-1.913-3.235-4.509-6.775-6.14l22.531-88.292c0.294,3.237,1.456,10.88,5.646,28.339
	l0.017,0.05c5.212,11.92,9.665,33.018,12.483,48.619c3.01,16.655,4.846,30.75,4.919,31.314c0.014,0.78,0.52,25.493,4.52,53.698
	C191.855,361.296,189.93,445.599,189.792,451.392 M233.017,272.446c-0.01,0.74-0.021,1.507-0.022,2.262
	c-0.004,1.561-0.008,3.123-0.012,4.685c-0.012,3.795-0.028,7.653-0.046,11.466c-0.022,4.583-0.049,9.122-0.079,13.49
	c-0.037,5.126-0.076,9.899-0.124,14.591c-0.054,5.298-0.112,10.129-0.178,14.767c-0.02,1.329-0.038,2.621-0.059,3.881
	c-0.056,3.614-0.116,6.96-0.183,10.141c-0.097,4.753-0.197,8.677-0.314,12.352c-0.09,2.882-0.208,6.294-0.396,9.756l-0.012,0.223
	c-0.107,1.975-0.217,4.018-0.474,6.003c-0.038,0.288-0.086,0.627-0.15,0.96c-2.028,10.476-1.782,30.459-0.972,37.849
	c0.811,7.387-0.989,30.032-1.169,32.253c-1.316,0.619-11.034,4.923-25.736,4.627c-4.661-0.094-8.842-0.198-12.69-0.338
	c0.067-2.751,0.556-23.925,0.601-47.938c0.04-21.542-0.279-49.445-1.935-65.52c-0.161-1.578-0.337-3.043-0.526-4.376
	c-4.037-28.479-4.51-53.391-4.515-53.639l-0.002-0.034c-0.018-0.143-1.865-14.43-4.923-31.358c-0.559-3.091-1.181-6.398-1.861-9.807
	c-2.757-13.819-6.458-29.317-10.654-38.926c-6.296-26.234-5.72-30.134-5.694-30.281l-0.161-0.038l0.162,0.031
	c2.776-14.835,5.272-35.686,5.707-42.096c0.143-2.111,0.383-8.946,0.639-17.11c0.1,0.173,0.201,0.347,0.301,0.519
	c0.729,1.256,1.499,2.596,2.354,4.099c1.175,2.062,2.4,4.239,3.644,6.47c1.553,2.79,3.134,5.665,4.7,8.549
	c1.85,3.407,3.71,6.883,5.528,10.329c2.076,3.937,4.138,7.911,6.126,11.815c2.224,4.364,4.409,8.74,6.493,13.006
	c2.294,4.691,4.525,9.368,6.63,13.899c2.288,4.924,4.487,9.801,6.536,14.499c2.206,5.057,4.296,10.036,6.212,14.802
	c2.048,5.093,3.951,10.075,5.657,14.808c1.326,3.679,2.525,7.176,3.63,10.591c0.427,1.319,0.841,2.627,1.242,3.927
	c1.523,4.936,2.784,9.495,3.857,13.933l0.143,0.593c1.063,4.392,2.163,8.934,2.577,13.415
	C233.079,267.863,233.048,270.194,233.017,272.446"
      />
      <path
        d="M474.693,245.165c-0.001-0.606-0.206-61.273-3.919-120.842c-1.942-31.146-5.349-49.795-7.866-59.956
	c-1.096-4.422-2.113-7.653-2.946-9.946c-0.149-0.171-0.207-0.462-0.246-0.669c-0.495-1.311-0.912-2.269-1.228-2.936
	c-0.317-0.667-0.532-1.043-0.619-1.188l-1.426-17.748c-0.023-0.082-0.005-0.186-0.006-0.263c0-0.004-0.001-0.008-0.001-0.013v-0.01
	c-0.006-0.084-0.016-0.163-0.035-0.245c-0.007-0.024-0.014-0.047-0.022-0.07c-0.004-0.014-0.009-0.026-0.014-0.04
	c-0.001-0.001,0,0,0-0.001c-0.001,0-0.001,0-0.001-0.001c-0.003-0.007-0.005-0.013-0.009-0.019
	c-0.006-0.013-0.013-0.026-0.021-0.038c-0.003-0.005-0.006-0.01-0.009-0.015h-0.002l-0.173-0.028
	c-0.125-0.02-12.646-2.022-28.915-3.859c-14.502-1.638-34.932-3.463-51.22-3.054c-16.288-0.409-36.719,1.416-51.222,3.054
	c-14.694,1.66-26.329,3.454-28.536,3.8c-0.278,0.206-0.5,0.426-0.67,0.773l0.002-0.002l-1.428,17.779
	c-0.171,0.286-0.835,1.461-1.794,3.985c0,0.015-0.003,0.031-0.011,0.048c-0.031,0.057-0.046,0.12-0.063,0.181
	c-0.019,0.07-0.043,0.137-0.068,0.205c-0.028,0.067-0.053,0.137-0.08,0.206c-0.014,0.034-0.032,0.067-0.053,0.097
	c-0.837,2.299-1.864,5.55-2.971,10.017c-2.517,10.161-5.924,28.81-7.865,59.956c-0.579,9.283-1.107,19.159-1.572,29.354
	c-0.032,0.721-0.064,1.44-0.097,2.158c-0.026,0.58-0.05,1.16-0.076,1.739c-0.394,9.052-0.745,18.502-1.044,28.088
	c-0.037,1.222-0.074,2.431-0.109,3.628c-0.023,0.768-0.046,1.532-0.067,2.29c-0.884,30.79-0.954,53.361-0.955,53.58l-1.143,64.658
	v0.014l0.001,0.015c0.035,0.43,3.435,43.011,3.919,48.983c0.483,5.962,0.974,44.815,0.978,45.201
	c-0.004,0.53-0.484,53.171,0.001,61.574c0.489,8.482,1.309,16.226,1.828,17.263c0.079,0.161,0.162,0.326,2.397,0.739
	c1.435,0.266,3.386,0.561,5.641,0.851c3.226,0.415,9.892,1.181,18.296,1.639c12.82,0.701,30.449,0.735,41.627-3.076l0.167-0.057
	l0.033-0.173c0.793-4.062,4.901-39.943,5.564-59.808c0.654-19.623-0.995-68.291-1.471-73.999c-0.462-5.551-1.014-37.483,0.648-45.63
	c1.288-6.308,4.203-27.763,5.769-39.289c0.422-3.106,0.755-5.558,0.928-6.774c0.28-1.955,0.385-5.699,0.519-10.437
	c0.248-8.85,0.589-20.971,2.414-27.733c1.579-5.854,2.733-12.528,3.529-17.556h0.003c0.001-0.021,0.003-0.04,0.005-0.059
	c0.004-0.047,0.009-0.093,0.019-0.138c0-0.003,0.001-0.004,0.001-0.008c0.001-0.011,0.002-0.021,0.003-0.032
	c0.002-0.027,0.005-0.055,0.011-0.082c0.002-0.017,0.006-0.034,0.013-0.051c0.002-0.01,0.006-0.02,0.008-0.03
	c0.001-0.003,0.004-0.011,0.005-0.017c0,0.004-0.001,0.008-0.001,0.013c0.001-0.01,0.004-0.019,0.006-0.028l-0.003-0.013
	c0.16-1.024,0.306-1.975,0.437-2.829c0.323-2.109,0.557-3.634,0.698-4.15c0.107-0.396,0.166-1.703,0.278-4.386
	c0.185-4.448,0.465-11.167,1.282-17.13c0.958-7.001,2.388-10.946,4.247-11.73h0.045c1.858,0.784,3.287,4.729,4.247,11.73
	c0.816,5.963,1.096,12.682,1.28,17.13c0.113,2.683,0.171,3.99,0.278,4.386c0.141,0.516,0.374,2.041,0.698,4.15
	c0.04,0.26,0.081,0.53,0.124,0.805c-0.012,0.235-0.019,0.37-0.02,0.39l0.08,0.003c0.074,0.477,0.151,0.974,0.231,1.492
	c0.002,0.004,0.005,0.008,0.007,0.013c0.058,0.196,0.079,0.423,0.088,0.642c0.003,0.002,0.007,0.003,0.01,0.003
	c0.795,5.019,1.946,11.657,3.518,17.482c1.824,6.762,2.165,18.883,2.413,27.733c0.132,4.738,0.238,8.482,0.518,10.437
	c0.173,1.216,0.506,3.668,0.928,6.774c1.566,11.526,4.482,32.981,5.769,39.289c1.663,8.147,1.111,40.079,0.648,45.63
	c-0.476,5.708-2.124,54.376-1.47,73.999c0.662,19.865,4.77,55.746,5.563,59.808l0.033,0.173l0.168,0.057
	c7.776,2.652,18.671,3.441,28.898,3.441c4.476,0,8.826-0.152,12.729-0.365c8.405-0.458,15.07-1.224,18.296-1.639
	c2.254-0.29,4.204-0.585,5.639-0.851c2.236-0.413,2.319-0.578,2.399-0.739c0.517-1.037,1.338-8.781,1.828-17.263
	c0.484-8.403,0.005-61.044,0-61.568c0.005-0.392,0.496-39.245,0.979-45.207c0.484-5.972,3.884-48.553,3.918-48.983l0.001-0.015
	L474.693,245.165z M474.083,245.171l0.256,14.441c-11.324-1.736-23.566-4.512-24.256-4.669c-0.802-0.364-18.091-8.229-21.573-12.484
	c-0.432-0.529-0.782-3.3,1.732-15.921c1.548-7.772,3.974-18.282,7.211-31.24c3.5-14.017,7.211-27.927,9.469-36.267
	c-0.209,1.111-0.424,2.273-0.636,3.441c-2.116,11.692-1.807,12.533-1.706,12.809c0.629,1.715,7.254,8.272,13.148,11.529
	c3.507,1.94,10.229,2.587,15.337,2.787C474.003,221.447,474.082,244.794,474.083,245.171 M473.047,188.987
	c-5.036-0.2-11.63-0.834-15.024-2.71c-5.674-3.137-12.282-9.603-12.871-11.206c-0.42-1.147,2.055-14.644,3.856-23.614l22.738,2.523
	C472.301,166.243,472.725,178.102,473.047,188.987 M452.929,31.26c0.04,0.005,0.081,0.012,0.122,0.019
	c0.037,0.005,0.073,0.01,0.11,0.016c0.036,0.005,0.072,0.01,0.107,0.016c0.164,0.024,0.321,0.048,0.472,0.071
	c0.04,0.006,0.08,0.012,0.121,0.018c0.059,0.008,0.117,0.018,0.175,0.027c0.039,0.005,0.078,0.012,0.115,0.017
	c0.039,0.005,0.077,0.012,0.115,0.017c0.036,0.007,0.074,0.012,0.109,0.017c0.017,0.004,0.032,0.006,0.048,0.008
	c0.054,0.008,0.109,0.017,0.162,0.024c0.013,0.003,0.027,0.005,0.04,0.007c0.054,0.009,0.106,0.016,0.157,0.024
	c0.073,0.011,0.143,0.022,0.21,0.033c0.029,0.004,0.057,0.009,0.084,0.013c0.054,0.007,0.107,0.016,0.157,0.024
	c0.025,0.004,0.05,0.007,0.074,0.012c0.069,0.011,0.132,0.02,0.191,0.03c0.022,0.003,0.042,0.006,0.062,0.009
	c0.101,0.015,0.187,0.029,0.257,0.04l1.423,17.709l-3.73-0.1l-0.706-18.071C452.846,31.247,452.888,31.254,452.929,31.26
	 M438.334,29.234c0.202,0.025,0.401,0.051,0.599,0.077c0.043,0.005,0.086,0.011,0.13,0.017c0.034,0.004,0.07,0.009,0.104,0.013
	c0.03,0.004,0.061,0.008,0.092,0.012c0.063,0.009,0.125,0.017,0.188,0.025c0.026,0.003,0.051,0.006,0.077,0.009
	c0.098,0.013,0.196,0.026,0.293,0.039h0.003c0.006,0.001,0.011,0.001,0.016,0.002c0.051,0.007,0.101,0.014,0.152,0.02
	c0.004,0,0.009,0.001,0.013,0.001c0.035,0.005,0.071,0.01,0.106,0.015c0.097,0.012,0.193,0.025,0.288,0.037
	c0.12,0.016,0.24,0.031,0.359,0.048c0.021,0.003,0.044,0.005,0.065,0.008c0.05,0.007,0.099,0.013,0.149,0.019
	c0.04,0.007,0.08,0.011,0.12,0.017c0.054,0.007,0.108,0.015,0.161,0.021c0.036,0.005,0.072,0.01,0.107,0.014
	c0.152,0.021,0.304,0.041,0.453,0.06c0.092,0.013,0.185,0.025,0.276,0.037c0.195,0.027,0.388,0.053,0.58,0.078
	c0.17,0.023,0.338,0.046,0.506,0.068c0.001,0,0.003,0.001,0.004,0.001c0.169,0.023,0.337,0.046,0.503,0.068
	c0.007,0.001,0.016,0.002,0.023,0.004c0.075,0.01,0.15,0.02,0.225,0.03c0.012,0.002,0.025,0.004,0.036,0.005
	c0.071,0.01,0.14,0.019,0.21,0.029c0.016,0.002,0.033,0.004,0.05,0.006c0.172,0.023,0.342,0.047,0.512,0.07
	c0.085,0.012,0.169,0.024,0.251,0.035c0.051,0.007,0.1,0.014,0.151,0.021c0.033,0.005,0.067,0.009,0.1,0.013
	c0.045,0.006,0.092,0.013,0.137,0.02c0.156,0.021,0.311,0.043,0.465,0.064c0.126,0.017,0.251,0.035,0.375,0.052
	c0.028,0.004,0.054,0.008,0.083,0.012c0.053,0.007,0.104,0.015,0.156,0.021c0.022,0.004,0.046,0.007,0.068,0.011
	c0.037,0.005,0.075,0.01,0.111,0.015c0.019,0.002,0.038,0.005,0.056,0.007c0.019,0.003,0.039,0.006,0.057,0.009
	c0.06,0.007,0.119,0.016,0.177,0.023c0.015,0.004,0.029,0.006,0.044,0.007c0.139,0.021,0.279,0.04,0.416,0.058
	c0.227,0.034,0.451,0.065,0.67,0.096c0.073,0.011,0.147,0.021,0.218,0.031c0.021,0.003,0.041,0.006,0.062,0.009
	c0.003,0,0.005,0.001,0.009,0.001c0.055,0.007,0.112,0.016,0.167,0.024c0.026,0.002,0.052,0.007,0.078,0.01
	c0.022,0.005,0.044,0.008,0.066,0.01c0.067,0.01,0.134,0.019,0.2,0.029c0.091,0.013,0.179,0.026,0.268,0.037
	c0.068,0.011,0.136,0.021,0.204,0.031c0.09,0.012,0.178,0.026,0.266,0.038c0.078,0.011,0.153,0.022,0.228,0.033
	c0.102,0.015,0.201,0.03,0.301,0.044c0.064,0.01,0.128,0.018,0.191,0.028c0.016,0.002,0.032,0.004,0.048,0.006
	c0.093,0.014,0.183,0.027,0.274,0.04c0.026,0.005,0.052,0.008,0.077,0.012c0.01,0.001,0.018,0.003,0.028,0.004
	c0.044,0.007,0.089,0.013,0.133,0.018c0.008,0.003,0.018,0.004,0.027,0.005c0.052,0.007,0.102,0.015,0.153,0.022
	c0.119,0.018,0.237,0.035,0.352,0.052c0.058,0.009,0.115,0.017,0.172,0.026c0.057,0.007,0.113,0.016,0.169,0.025
	c0.056,0.008,0.112,0.016,0.167,0.024c0.053,0.008,0.107,0.016,0.161,0.024c0.007,0.001,0.014,0.002,0.02,0.003
	c0.03,0.004,0.058,0.009,0.087,0.013c0.004,0.001,0.009,0.001,0.013,0.002l0.709,18.146l0.024,0.611l0.351,8.963
	c0.01,0.269-0.09,0.522-0.279,0.713c-0.189,0.191-0.441,0.289-0.711,0.282l-13.255-0.427c-0.309-0.01-0.559-0.261-0.567-0.572
	l-0.227-9.353l-0.013-0.61l-0.479-19.744C437.941,29.184,438.139,29.209,438.334,29.234 M427.164,27.884
	c0.588,0.065,1.17,0.132,1.746,0.198c0.232,0.027,0.461,0.053,0.69,0.081c0.115,0.013,0.229,0.026,0.343,0.04
	c0.228,0.026,0.456,0.053,0.682,0.079c0.227,0.027,0.452,0.054,0.676,0.081c0.112,0.013,0.224,0.027,0.336,0.04
	s0.224,0.027,0.335,0.04c0.222,0.026,0.444,0.054,0.665,0.081c1.549,0.187,3.05,0.373,4.494,0.556l0.481,19.805l-43.672-1.169
	l5.552-22.304C409.391,26.023,419.177,26.982,427.164,27.884 M374.308,24.8l0.003,0.085c0.562-0.02,1.131-0.037,1.704-0.051
	c0.572,0.014,1.141,0.031,1.703,0.051l0.003-0.085c6.654-0.104,13.923,0.14,21.151,0.575l-6.807,27.349
	c-0.089,0.362-0.413,0.615-0.785,0.615h-31.619c-0.374,0-0.698-0.254-0.786-0.618L352.2,25.434
	C359.743,24.963,367.361,24.691,374.308,24.8 M315.329,29.026c0.282-0.036,0.567-0.072,0.855-0.109
	c0.413-0.051,0.829-0.103,1.25-0.155c0.824-0.101,1.662-0.203,2.515-0.305c0.147-0.017,0.296-0.036,0.444-0.054
	c0.223-0.027,0.447-0.054,0.673-0.08c0.339-0.041,0.679-0.08,1.021-0.12c0.912-0.107,1.839-0.213,2.779-0.319
	c7.73-0.873,17.145-1.799,26.715-2.411l5.442,22.248l-42.175,1.146L315.329,29.026z M300.287,31.083
	c0.084-0.013,0.17-0.026,0.257-0.038c0.027-0.004,0.055-0.009,0.084-0.013c0.058-0.009,0.116-0.017,0.175-0.026
	c0.136-0.02,0.275-0.041,0.416-0.061c0.056-0.008,0.113-0.016,0.172-0.025c0.046-0.006,0.092-0.014,0.139-0.02
	c0.304-0.044,0.617-0.09,0.941-0.137c0.413-0.059,0.842-0.12,1.288-0.184c0.072-0.01,0.146-0.022,0.218-0.031
	c0.105-0.015,0.211-0.03,0.319-0.045c0.19-0.027,0.385-0.055,0.581-0.083c0.536-0.076,1.093-0.153,1.668-0.232
	c0.411-0.057,0.832-0.115,1.263-0.174c0.185-0.025,0.373-0.05,0.561-0.076c0.149-0.02,0.3-0.041,0.453-0.061
	c0.011-0.001,0.024-0.004,0.036-0.006c0.179-0.023,0.357-0.047,0.539-0.072c0.09-0.012,0.181-0.023,0.272-0.037
	c0.224-0.029,0.449-0.06,0.677-0.09c0.05-0.006,0.102-0.013,0.152-0.02c0.234-0.031,0.47-0.061,0.706-0.094
	c0.238-0.031,0.477-0.062,0.719-0.094c0.096-0.012,0.193-0.025,0.29-0.038c0.195-0.025,0.39-0.051,0.588-0.077
	c0.59-0.077,1.193-0.154,1.805-0.232c0.037-0.004,0.074-0.009,0.111-0.014l-0.479,19.78l-0.015,0.611l-0.227,9.371
	c-0.008,0.311-0.256,0.562-0.566,0.572l-13.255,0.427c-0.27,0.008-0.522-0.091-0.711-0.282c-0.191-0.191-0.289-0.444-0.279-0.713
	l0.341-8.976l0.023-0.611l0.692-18.193C300.256,31.087,300.271,31.085,300.287,31.083 M296.213,31.702
	c0.028-0.004,0.058-0.009,0.092-0.014c0.053-0.009,0.115-0.018,0.183-0.029c0.021-0.003,0.044-0.006,0.066-0.011
	c0.047-0.007,0.095-0.014,0.147-0.022c0.05-0.008,0.104-0.016,0.161-0.025c0.09-0.014,0.188-0.029,0.291-0.045
	c0.091-0.014,0.186-0.029,0.286-0.044c0.073-0.011,0.147-0.023,0.223-0.035c0.07-0.01,0.141-0.021,0.215-0.033
	c0.192-0.029,0.397-0.06,0.616-0.093c0.043-0.007,0.088-0.013,0.132-0.02c0.072-0.011,0.146-0.023,0.222-0.033
	c0.047-0.008,0.094-0.014,0.143-0.022c0.051-0.007,0.105-0.016,0.159-0.023c0.048-0.008,0.097-0.015,0.146-0.023
	c0.109-0.016,0.22-0.032,0.332-0.05l-0.689,18.119l-4.148,0.112L296.213,31.702z M279.078,185.681
	c0.297-9.584,0.648-19.031,1.043-28.08c0.024-0.579,0.05-1.159,0.076-1.739c0.028-0.631,0.056-1.264,0.085-1.896l22.612-2.509
	c1.801,8.97,4.276,22.467,3.856,23.614c-0.589,1.603-7.197,8.069-12.871,11.206c-3.367,1.861-9.882,2.5-14.903,2.705
	C279.01,187.89,279.043,186.791,279.078,185.681 M277.946,245.167c0.001-0.225,0.071-22.788,0.954-53.57
	c0.019-0.664,0.038-1.333,0.059-2.004c5.094-0.206,11.736-0.859,15.215-2.783c5.893-3.257,12.519-9.814,13.148-11.529
	c0.101-0.276,0.41-1.117-1.706-12.809c-0.212-1.168-0.427-2.33-0.636-3.441c2.258,8.34,5.968,22.25,9.47,36.266
	c3.235,12.959,5.662,23.469,7.21,31.24c2.514,12.622,2.164,15.393,1.732,15.922c-3.481,4.255-20.771,12.12-21.573,12.484
	c-0.688,0.156-12.841,2.913-24.128,4.649L277.946,245.167z M375.628,160.39c-2.034,0.994-3.504,4.975-4.487,12.152
	c-0.821,5.992-1.101,12.729-1.287,17.187c-0.09,2.182-0.162,3.906-0.256,4.252c-0.108,0.396-0.254,1.264-0.455,2.542
	c-0.409-8.515-1.526-32.638-1.182-35.835c0.228-2.122,1.908-3.532,2.889-4.185c1.599-1.064,3.522-1.588,4.778-1.322V160.39z
	 M375.628,154.561c-1.421-0.245-3.416,0.303-5.116,1.434c-1.847,1.228-2.968,2.872-3.158,4.627
	c-0.421,3.921,1.254,37.468,1.326,38.894h0.003c-0.076,0.495-0.157,1.015-0.242,1.554c-7.064,1.658-15.238-1.026-24.311-7.99
	c-7.836-6.012-13.354-12.539-16.4-19.395c-3.737-8.41-10.957-29.574,2.657-44.438c9.473-10.34,21.386-15.516,29.712-18.038
	c7.716-2.336,13.858-2.887,15.529-3V154.561z M375.628,107.598c-1.645,0.109-7.869,0.656-15.687,3.023
	c-5.347,1.617-10.387,3.756-14.978,6.357c-5.743,3.254-10.799,7.244-15.026,11.858c-5.314,5.802-8.03,13.188-8.072,21.951
	c-0.043,9.159,2.863,17.642,5.308,23.145c3.087,6.951,8.668,13.556,16.586,19.633c4.113,3.157,8.084,5.472,11.8,6.879
	c4.537,1.717,8.832,2.146,12.78,1.275c-0.793,4.984-1.93,11.514-3.477,17.244c-1.843,6.831-2.185,18.994-2.434,27.875
	c-0.127,4.531-0.238,8.446-0.512,10.367c-0.173,1.218-0.507,3.671-0.93,6.777c-1.565,11.52-4.478,32.962-5.761,39.249
	c-1.672,8.193-1.122,40.237-0.658,45.803c0.475,5.704,2.122,54.323,1.468,73.929c-0.653,19.582-4.656,54.735-5.519,59.537
	c-10.966,3.679-28.145,3.675-40.657,3.02c-14.234-0.747-25.442-2.498-26.419-2.98c-0.424-1.06-1.23-8.153-1.739-16.969
	c-0.484-8.384-0.004-61.005,0-61.542c-0.004-0.392-0.495-39.266-0.98-45.248c-0.481-5.931-3.838-47.973-3.918-48.968l0.877-49.602
	c11.612-1.781,24.177-4.652,24.304-4.681l0.03-0.006l0.027-0.013c0.742-0.334,18.186-8.222,21.822-12.666
	c0.575-0.703,1.035-3.17-1.605-16.428c-1.55-7.78-3.978-18.301-7.217-31.268c-5.514-22.076-11.548-43.889-11.609-44.107l-0.07-0.25
	l-23.052,2.558c0.459-10.067,0.982-19.818,1.555-28.989c1.272-20.425,3.176-35.46,5.042-46.242c0.709-0.06,2.96-0.247,6.53-0.504
	l1.207,14.677c0.086,1.041,1,1.877,2.128,1.946L354.6,97.74c0.052,0.003,0.102,0.005,0.152,0.005c1.201,0,2.208-0.865,2.278-1.99
	l1.299-20.926c5.469-0.091,11.255-0.152,17.299-0.17V107.598z M302.732,79.643h0.036l45.624-1.657
	c0.718-0.026,1.28-0.655,1.28-1.433v-1.55c2.595-0.061,5.279-0.117,8.044-0.164l-1.295,20.878c-0.051,0.837-0.853,1.47-1.784,1.415
	l-57.828-3.503c-0.827-0.051-1.496-0.646-1.558-1.388l-1.205-14.67c2.082-0.148,4.577-0.318,7.443-0.499l0.155,1.522
	C301.705,79.189,302.179,79.643,302.732,79.643 M302.13,77.031c9.805-0.615,23.77-1.351,40.413-1.839
	c2.091-0.062,4.256-0.12,6.487-0.174v1.535c0,0.424-0.297,0.779-0.661,0.792l-45.624,1.656c-0.23,0.008-0.435-0.199-0.463-0.472
	L302.13,77.031z M342.521,74.582c-30.731,0.901-52.335,2.65-55.506,2.916c0.933-5.311,1.854-9.564,2.677-12.9
	c2.43-9.831,4.516-13.817,4.944-14.572l4.279-0.117l-0.339,8.937c-0.017,0.434,0.149,0.859,0.456,1.165
	c0.293,0.296,0.696,0.463,1.113,0.463h0.049l13.255-0.428c0.634-0.02,1.141-0.533,1.156-1.165l0.228-9.404l42.339-1.149l1.11,4.538
	c0.156,0.637,0.723,1.082,1.379,1.082h31.619c0.653,0,1.22-0.442,1.378-1.076l1.132-4.55l43.835,1.174l0.228,9.385
	c0.016,0.632,0.523,1.145,1.157,1.165l13.255,0.428h0.049c0.416,0,0.82-0.167,1.114-0.463c0.305-0.306,0.472-0.731,0.456-1.166
	l-0.349-8.923l3.858,0.104c0.428,0.754,2.515,4.739,4.945,14.572c0.824,3.336,1.743,7.588,2.676,12.9
	c-20.263-1.774-42.203-2.88-65.22-3.284C381.261,73.887,361.991,74.011,342.521,74.582 M403.38,77.959l45.623,1.656h0.037
	c0.553,0,1.026-0.453,1.087-1.049l0.164-1.595l-0.337-0.035c2.786,0.191,5.58,0.397,8.376,0.618l-1.209,14.687
	c-0.061,0.742-0.73,1.337-1.556,1.388l-57.828,3.503c-0.933,0.057-1.733-0.578-1.785-1.415l-1.301-20.961
	c2.456,0.032,4.939,0.072,7.449,0.122v1.649C402.1,77.303,402.662,77.933,403.38,77.959 M402.742,76.527V74.89
	c14.977,0.305,30.835,0.928,46.909,2.025l-0.163,1.585c-0.028,0.274-0.232,0.482-0.462,0.472l-45.623-1.655
	C403.038,77.304,402.742,76.949,402.742,76.527 M382.812,196.057c-0.162-1.024-0.286-1.731-0.38-2.076
	c-0.095-0.346-0.166-2.07-0.258-4.252c-0.185-4.458-0.466-11.195-1.286-17.187c-1.009-7.367-2.53-11.365-4.65-12.223v-5.121
	c1.254-0.302,3.217,0.221,4.845,1.305c0.982,0.653,2.662,2.063,2.89,4.185C384.311,163.829,383.239,187.162,382.812,196.057
	 M383.277,199.065c0.212-4.271,1.703-34.719,1.303-38.443c-0.189-1.755-1.311-3.399-3.159-4.627
	c-1.727-1.149-3.758-1.698-5.183-1.423v-46.354c1.834,0.13,7.869,0.709,15.406,2.991c8.326,2.522,20.24,7.698,29.712,18.038
	c13.614,14.864,6.393,36.028,2.658,44.438c-3.047,6.856-8.565,13.383-16.401,19.395c-8.945,6.867-17.018,9.573-24.014,8.056
	C383.483,200.406,383.377,199.713,383.277,199.065 M471.309,358.781c-0.485,5.982-0.976,44.856-0.981,45.255
	c0.005,0.53,0.484,53.151,0.001,61.535c-0.509,8.816-1.314,15.909-1.741,16.969c-0.976,0.482-12.184,2.233-26.418,2.98
	c-12.512,0.655-29.691,0.659-40.657-3.02c-0.864-4.802-4.866-39.955-5.519-59.537c-0.653-19.606,0.994-68.225,1.469-73.929
	c0.464-5.566,1.013-37.61-0.658-45.803c-1.283-6.287-4.197-27.729-5.763-39.249c-0.421-3.106-0.754-5.559-0.929-6.777
	c-0.274-1.921-0.384-5.836-0.512-10.367c-0.25-8.881-0.59-21.044-2.434-27.875c-1.54-5.706-2.674-12.206-3.466-17.182
	c1.232,0.25,2.495,0.376,3.791,0.376c2.77,0,5.678-0.572,8.692-1.713c3.717-1.407,7.686-3.722,11.801-6.879
	c7.917-6.077,13.497-12.682,16.586-19.633c2.445-5.503,5.35-13.986,5.306-23.145c-0.042-8.763-2.758-16.149-8.072-21.951
	c-4.226-4.614-9.282-8.604-15.025-11.858c-4.591-2.601-9.631-4.74-14.977-6.357c-7.635-2.311-13.749-2.887-15.565-3.014V74.658
	c5.723-0.014,11.673,0.013,17.802,0.089l1.303,21.008c0.07,1.125,1.077,1.99,2.278,1.99c0.051,0,0.102-0.002,0.152-0.005
	l57.828-3.502c1.128-0.069,2.043-0.905,2.128-1.946l1.208-14.691c2.061,0.165,4.123,0.337,6.185,0.517
	c1.867,10.783,3.77,25.818,5.043,46.243c0.607,9.727,1.119,19.483,1.553,29.003l-23.179-2.572l-0.069,0.25
	c-0.06,0.218-6.095,22.031-11.609,44.107c-3.239,12.967-5.667,23.488-7.217,31.268c-2.64,13.258-2.181,15.725-1.605,16.428
	c3.636,4.444,21.081,12.332,21.822,12.666l0.028,0.013l0.028,0.006c0.127,0.029,12.785,2.922,24.433,4.7l0.876,49.583
	C475.147,310.808,471.79,352.85,471.309,358.781"
      />
    </svg>
  );
}
